    <template>
        <div class="floor-map" :class="[mode, { placing: mode === 'edit' && tool !== 'select' && tool !== 'ref' && !refMove, 'ref-move': refMove }]" :style="{ '--floor-w': viewWidth, '--floor-h': viewHeight }">
            <div class="floor-map-stage" ref="stage" @pointerdown="FloorOnStagePointerDown" @contextmenu.prevent>
                <!-- Chrome de edición: tools / mesas sueltas / tamaño / props. El SVG sigue abajo. -->
                <button
                    v-if="mode === 'edit'"
                    type="button"
                    class="secondary floor-map-toolbar-toggle floor-map-icon-btn"
                    v-tooltip="toolbarsDimmed ? 'Mostrar herramientas' : 'Ocultar herramientas'"
                    @pointerdown.stop
                    @click.stop="toolbarsDimmed = !toolbarsDimmed"
                ><i :class="toolbarsDimmed ? 'icon icon-invisible' : 'icon icon-eye'"></i></button>
                <button
                    v-else-if="!unplacedDisabled && !unplacedOpen"
                    type="button"
                    class="floor-map-toolbar-toggle floor-map-icon-btn"
                    :class="unplacedOpen ? 'primary' : 'secondary'"
                    :disabled="unplacedDisabled"
                    v-tooltip="unplacedDisabled ? 'No hay mesas fuera del mapa' : (unplacedOpen ? 'Ocultar mesas fuera del mapa' : 'Mesas fuera del mapa')"
                    @pointerdown.stop
                    @click.stop="$emit('toggle-unplaced')"
                ><i :class="unplacedOpen ? 'icon icon-eye' : 'icon icon-invisible'"></i></button>
                <div
                    v-if="mode === 'edit'"
                    class="floor-map-float-label"
                    :class="{ dimmed: toolbarsDimmed || !!drag || !!lineDraft || !!marquee }"
                    @pointerdown.stop
                    @click.stop
                >
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'select' ? 'primary' : 'secondary'" v-tooltip="'Seleccionar'" @click="FloorSetTool('select')">
                        <i class="icon icon-cursor"></i>
                    </button>
                    <span class="floor-map-tool-sep"></span>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'wall' ? 'primary' : 'secondary'" v-tooltip="'Pared (clic derecho para terminar)'" @click="FloorSetTool('wall')">
                        <i class="icon icon-wall"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'window' ? 'primary' : 'secondary'" v-tooltip="'Ventana'" @click="FloorSetTool('window')">
                        <i class="icon icon-curtain"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'door' ? 'primary' : 'secondary'" v-tooltip="'Puerta'" @click="FloorSetTool('door')">
                        <i class="icon icon-door"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'stairs' ? 'primary' : 'secondary'" v-tooltip="'Escalera'" @click="FloorSetTool('stairs')">
                        <i class="icon icon-stairs"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'column' ? 'primary' : 'secondary'" v-tooltip="'Pilar'" @click="FloorSetTool('column')">
                        <i class="icon icon-pillar"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'plant' ? 'primary' : 'secondary'" v-tooltip="'Planta'" @click="FloorSetTool('plant')">
                        <i class="icon icon-plant"></i>
                    </button>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'toilet' ? 'primary' : 'secondary'" v-tooltip="'Inodoro'" @click="FloorSetTool('toilet')">
                        <i class="icon icon-toilet"></i>
                    </button>
                    <span class="floor-map-tool-sep"></span>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'label' ? 'primary' : 'secondary'" v-tooltip="'Texto'" @click="FloorSetTool('label')">
                        <i class="icon icon-type-1"></i>
                    </button>
                    <template v-if="tool === 'label'">
                        <button type="button" class="secondary" v-for="p in labelPresets" :key="p" @click="pendingLabelText = p">{{ p }}</button>
                    </template>
                    <span class="floor-map-tool-sep"></span>
                    <button type="button" class="floor-map-icon-btn" :class="tool === 'ref' ? 'primary' : 'secondary'" v-tooltip="'Imagen de referencia'" @click="FloorUseRefTool">
                        <i class="icon icon-picture"></i>
                    </button>
                    <input ref="refImageInput" type="file" accept="image/*" hidden @change="FloorOnRefImage">
                </div>
                <div
                    v-if="mode === 'edit' && unplacedTables.length"
                    class="floor-map-unplaced-bar"
                    :class="{ dimmed: toolbarsDimmed || !!drag || !!lineDraft || !!marquee }"
                    @pointerdown.stop
                    @click.stop
                >
                    <span class="floor-unplaced-title">Mesas disponibles</span>
                    <span class="floor-map-tool-sep"></span>
                    <button
                        type="button"
                        class="secondary"
                        v-for="table in unplacedTables"
                        :key="table.id"
                        @click="FloorAddTable(table)">{{ table.name }}</button>
                </div>
                <div
                    v-if="mode === 'edit'"
                    class="floor-map-size-bar"
                    :class="{ dimmed: toolbarsDimmed || !!drag || !!lineDraft || !!marquee }"
                    @pointerdown.stop
                    @click.stop
                >
                    <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Disminuir tamaño'" :disabled="!sizeNudge.down" @click="FloorNudgeSize(-1)"><i class="icon icon-minus"></i></button>
                    <span class="floor-map-tool-sep"></span>
                    <button
                        type="button"
                        class="floor-map-icon-btn"
                        v-for="p in sizePresets"
                        :key="p.key"
                        :class="currentSizeKey === p.key ? 'primary' : 'secondary'"
                        v-tooltip="p.title"
                        @click="FloorSetSize(p)">{{ p.label }}</button>
                    <span class="floor-map-tool-sep"></span>
                    <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Aumentar tamaño'" :disabled="!sizeNudge.up" @click="FloorNudgeSize(1)"><i class="icon icon-plus"></i></button>
                </div>
                <div v-if="mode === 'edit' && ((tool === 'ref' && refImage) || isMultiSelect || selectedTableId || selectedEl)"
                    class="floor-map-float-label-rigth"
                    :class="{ dimmed: toolbarsDimmed || !!drag || !!lineDraft || !!marquee }"
                    @pointerdown.stop
                    @click.stop
                >
                    <template v-if="tool === 'ref' && refImage">
                        <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Alejar'" @click="FloorZoomRef(-1)"><i class="icon icon-minus"></i></button>
                        <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Acercar'" @click="FloorZoomRef(1)"><i class="icon icon-plus"></i></button>
                        <button type="button" class="floor-map-icon-btn" :class="refMove ? 'primary' : 'secondary'" v-tooltip="'Mover referencia'" @click="refMove = !refMove">
                            <i class="icon icon-expand-window" style="transform: rotate(45deg)"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Restablecer posición'" @click="FloorResetRef">
                            <i class="icon icon-update"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" v-tooltip="'Cambiar imagen'" @click="FloorPickRefImage">
                            <i class="icon icon-picture"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn error-color" v-tooltip="'Quitar imagen'" @click="FloorClearRef"><i class="icon icon-trash"></i></button>
                    </template>
                    <template v-else-if="isMultiSelect">
                        <button type="button" class="secondary floor-map-icon-btn error-color" @click="FloorRemoveSelection" v-tooltip="'Quitar selección'"><i class="icon icon-trash"></i></button>
                    </template>
                    <template v-else-if="selectedTableId">
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetShape('round')" :class="{selected: selectedShape === 'round'}" v-tooltip="'Redonda'">
                            <i class="icon icon-circle"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetShape('square')" :class="{selected: selectedShape === 'square'}" v-tooltip="'Cuadrada'">
                            <i class="icon icon-square"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetShape('diamond')" :class="{selected: selectedShape === 'diamond'}" v-tooltip="'Rombo'">
                            <i class="icon icon-rhombus"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetShape('rect')" :class="{selected: selectedShape === 'rect'}" v-tooltip="'Rectangular'">
                            <i class="icon icon-rectangle"></i>
                        </button>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeSelected(-1)" :disabled="!FloorResizeBtns(layoutDraft[selectedTableId], true).down" v-tooltip="'Reducir'"><i class="icon icon-minus"></i></button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeSelected(1)" :disabled="!FloorResizeBtns(layoutDraft[selectedTableId], true).up" v-tooltip="'Aumentar'"><i class="icon icon-plus"></i></button>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn error-color" @click="FloorRemoveFromMap" v-tooltip="'Quitar mesa'"><i class="icon icon-trash"></i></button>
                    </template>
                    <template v-else-if="selectedKind === 'label'">
                        <div class="input-field floor-label-name">
                            <div class="input-group flex w100">
                                <input type="text" v-model="selectedEl.text" @input="FloorEmitElements" placeholder="Texto">
                            </div>
                        </div>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetLabelShape('round')" :class="{selected: selectedEl.shape === 'round'}" v-tooltip="'Redonda'">
                            <i class="icon icon-circle"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetLabelShape('square')" :class="{selected: selectedEl.shape === 'square'}" v-tooltip="'Cuadrada'">
                            <i class="icon icon-square"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetLabelShape('rect')" :class="{selected: selectedEl.shape === 'rect'}" v-tooltip="'Rectangular'">
                            <i class="icon icon-rectangle"></i>
                        </button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorSetLabelShape('text')" :class="{selected: selectedEl.shape === 'text'}" v-tooltip="'Solo texto'">
                            <i class="icon icon-type-1"></i>
                        </button>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeLabel(-1)" :disabled="!FloorResizeBtns(selectedEl).down" v-tooltip="'Reducir'"><i class="icon icon-minus"></i></button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeLabel(1)" :disabled="!FloorResizeBtns(selectedEl).up" v-tooltip="'Aumentar'"><i class="icon icon-plus"></i></button>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn error-color" @click="FloorRemoveElement" v-tooltip="'Quitar'"><i class="icon icon-trash"></i></button>
                    </template>
                    <template v-else-if="selectedKind === 'stamp'">
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeStamp(-1)" :disabled="!FloorResizeBtns(selectedEl).down" v-tooltip="'Reducir'"><i class="icon icon-minus"></i></button>
                        <button type="button" class="secondary floor-map-icon-btn" @click="FloorResizeStamp(1)" :disabled="!FloorResizeBtns(selectedEl).up" v-tooltip="'Aumentar'"><i class="icon icon-plus"></i></button>
                        <template v-if="selectedEl.type === 'stairs' || selectedEl.type === 'toilet'">
                            <span class="floor-map-tool-sep"></span>
                            <button type="button" class="secondary floor-map-icon-btn" @click="FloorRotateStamp(-90)" v-tooltip="'Rotar izquierda'">
                                <i class="icon icon-revert"></i>
                            </button>
                            <button type="button" class="secondary floor-map-icon-btn" @click="FloorRotateStamp(90)" v-tooltip="'Rotar derecha'">
                                <i class="icon icon-revert" style="transform: scaleX(-1)"></i>
                            </button>
                        </template>
                        <span class="floor-map-tool-sep"></span>
                        <button type="button" class="secondary floor-map-icon-btn error-color" @click="FloorRemoveElement" v-tooltip="'Quitar'"><i class="icon icon-trash"></i></button>
                    </template>
                    <template v-else-if="selectedKind === 'segment'">
                        <template v-if="selectedEl.type === 'door'">
                            <button type="button" class="secondary floor-map-icon-btn" @click="FloorRotateDoor(-90)" v-tooltip="'Rotar izquierda'">
                                <i class="icon icon-revert"></i>
                            </button>
                            <button type="button" class="secondary floor-map-icon-btn" @click="FloorRotateDoor(90)" v-tooltip="'Rotar derecha'">
                                <i class="icon icon-revert" style="transform: scaleX(-1)"></i>
                            </button>
                            <span class="floor-map-tool-sep"></span>
                        </template>
                        <button type="button" class="secondary floor-map-icon-btn error-color" @click="FloorRemoveElement" v-tooltip="'Quitar'"><i class="icon icon-trash"></i></button>
                    </template>
                </div>

                <div class="floor-map-scroll">
                <div class="floor-map-sizer">
                <svg class="floor-map-svg" :viewBox="'0 0 ' + viewWidth + ' ' + viewHeight" preserveAspectRatio="xMidYMid meet" @wheel="FloorOnRefWheel">
                    <defs>
                        <pattern id="floor-grid" :width="gridSize" :height="gridSize" patternUnits="userSpaceOnUse">
                            <path class="floor-grid-line" :d="'M ' + gridSize + ' 0 L 0 0 0 ' + gridSize" fill="none" stroke-width="0.15"/>
                        </pattern>
                    </defs>
                    <rect class="floor-canvas" x="0" y="0" :width="viewWidth" :height="viewHeight"/>
                    <image
                        v-if="mode === 'edit' && refImage"
                        :href="refImage"
                        v-bind="{ 'xlink:href': refImage }"
                        :x="refBox.x"
                        :y="refBox.y"
                        :width="refBox.w"
                        :height="refBox.h"
                        preserveAspectRatio="xMidYMid meet"
                        opacity="0.15"
                        pointer-events="none"
                    />
                    <rect v-if="mode === 'edit'" x="0" y="0" :width="viewWidth" :height="viewHeight" fill="url(#floor-grid)"/>

                    <!-- capa plano: paredes / ventanas / puertas / sellos / labels -->
                    <g class="floor-elements">
                        <g
                            v-for="el in liveByType.wall"
                            :key="el.id"
                            class="floor-wall"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <path class="floor-wall-hit" :d="el.d"/>
                            <path class="floor-segment wall" :d="el.d"/>
                        </g>
                        <g
                            v-for="el in liveByType.window"
                            :key="el.id"
                            class="floor-window"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <path class="floor-window-fill" :d="el.geom.fill"/>
                            <line class="floor-window-hit" :x1="el.x1" :y1="el.y1" :x2="el.x2" :y2="el.y2"/>
                            <line class="floor-window-line" :x1="el.geom.a.x1" :y1="el.geom.a.y1" :x2="el.geom.a.x2" :y2="el.geom.a.y2"/>
                            <line class="floor-window-line" :x1="el.geom.b.x1" :y1="el.geom.b.y1" :x2="el.geom.b.x2" :y2="el.geom.b.y2"/>
                        </g>
                        <g
                            v-for="el in liveByType.door"
                            :key="el.id"
                            class="floor-door"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <line class="floor-door-hit" :x1="el.x1" :y1="el.y1" :x2="el.x2" :y2="el.y2"/>
                            <path class="floor-door-frame" :d="el.geom.frame"/>
                            <path class="floor-door-arc" :d="el.geom.arc"/>
                        </g>
                        <g
                            v-for="el in liveByType.stairs"
                            :key="el.id"
                            class="floor-stamp stairs"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            :transform="`translate(${el.x} ${el.y})`"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <rect class="floor-stamp-hit" :width="el.w" :height="el.h"/>
                            <rect class="floor-stairs-outline" :width="el.w" :height="el.h"/>
                            <line
                                v-for="(ln, i) in stairsStepLines(el.w, el.h, el.rotation)"
                                :key="'s'+i"
                                class="floor-stairs-step"
                                :x1="ln.x1" :y1="ln.y1" :x2="ln.x2" :y2="ln.y2"
                            />
                            <path class="floor-stairs-arrow" :d="stairsArrowPath(el.w, el.h, el.rotation)"/>
                        </g>
                        <g
                            v-for="el in liveByType.column"
                            :key="el.id"
                            class="floor-stamp column"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            :transform="`translate(${el.x} ${el.y})`"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <rect class="floor-stamp-hit" :width="el.w" :height="el.h"/>
                            <circle class="floor-column-outer" :cx="el.w / 2" :cy="el.h / 2" :r="Math.min(el.w, el.h) / 2"/>
                            <circle class="floor-column-core" :cx="el.w / 2" :cy="el.h / 2" :r="Math.min(el.w, el.h) / 6"/>
                        </g>
                        <g
                            v-for="el in liveByType.plant"
                            :key="el.id"
                            class="floor-stamp plant"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            :transform="`translate(${el.x} ${el.y})`"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <rect class="floor-stamp-hit" :width="el.w" :height="el.h"/>
                            <svg class="floor-stamp-ink" :viewBox="iconPlant.vb" :x="-el.w * 0.05" :y="-el.h * 0.05" :width="el.w * 1.1" :height="el.h * 1.1" preserveAspectRatio="xMidYMid meet">
                                <path v-for="(d, i) in iconPlant.d" :key="i" :d="d"/>
                            </svg>
                        </g>
                        <g
                            v-for="el in liveByType.toilet"
                            :key="el.id"
                            class="floor-stamp toilet"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit' }"
                            :transform="`translate(${el.x} ${el.y}) rotate(${el.rotation || 0} ${el.w / 2} ${el.h / 2})`"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <rect class="floor-stamp-hit" :width="el.w" :height="el.h"/>
                            <svg class="floor-stamp-ink" :viewBox="iconWc.vb" :x="-el.w * 0.05" :y="-el.h * 0.05" :width="el.w * 1.1" :height="el.h * 1.1" preserveAspectRatio="xMidYMid meet">
                                <path v-for="(d, i) in iconWc.d" :key="i" :d="d"/>
                            </svg>
                        </g>
                        <g
                            v-for="el in liveByType.label"
                            :key="el.id"
                            class="floor-label-node"
                            :class="{ selected: FloorElementIsSelected(el.id), editable: mode === 'edit', 'text-only': el.shape === 'text' }"
                            :transform="`translate(${el.x} ${el.y})`"
                            @pointerdown.stop="FloorOnElementPointerDown($event, el)"
                            @click.stop="FloorOnElementClick(el)"
                        >
                            <rect class="floor-stamp-hit" :width="el.w" :height="el.h"/>
                            <ellipse v-if="el.shape === 'round'" :cx="el.w / 2" :cy="el.h / 2" :rx="el.w / 2" :ry="el.h / 2"/>
                            <rect v-else-if="el.shape !== 'text'" :x="0" :y="0" :width="el.w" :height="el.h" :rx="el.shape === 'square' ? 0.8 : 1.2" :ry="el.shape === 'square' ? 0.8 : 1.2"/>
                            <text :x="el.w / 2" :y="el.h / 2" text-anchor="middle" dominant-baseline="middle" class="floor-label-text" :style="{ fontSize: floorFitFont(el.text, el.w, el.h, FloorLabelFont(el)) + 'px' }">{{ el.text }}</text>
                        </g>
                        <line
                            v-if="lineDraft && lineDraft.type === 'wall'"
                            class="floor-segment draft"
                            :class="lineDraft.type"
                            :x1="lineDraft.x1" :y1="lineDraft.y1" :x2="lineDraft.x2" :y2="lineDraft.y2"
                        />
                        <circle
                            v-if="pathDraft"
                            class="floor-wall-vertex"
                            :cx="pathDraft.x"
                            :cy="pathDraft.y"
                            r="1.2"
                        />
                        <circle
                            v-if="pathDraft && pathDraft.id"
                            class="floor-wall-vertex"
                            :cx="pathDraft.firstX"
                            :cy="pathDraft.firstY"
                            r="1.2"
                        />
                        <g v-if="lineDraftGeom && lineDraft.type === 'window'" class="floor-window draft">
                            <path class="floor-window-fill" :d="lineDraftGeom.fill"/>
                            <line class="floor-window-line" :x1="lineDraftGeom.a.x1" :y1="lineDraftGeom.a.y1" :x2="lineDraftGeom.a.x2" :y2="lineDraftGeom.a.y2"/>
                            <line class="floor-window-line" :x1="lineDraftGeom.b.x1" :y1="lineDraftGeom.b.y1" :x2="lineDraftGeom.b.x2" :y2="lineDraftGeom.b.y2"/>
                        </g>
                        <g v-if="lineDraftGeom && lineDraft.type === 'door'" class="floor-door draft">
                            <path class="floor-door-frame" :d="lineDraftGeom.frame"/>
                            <path class="floor-door-arc" :d="lineDraftGeom.arc"/>
                        </g>
                    </g>

                    <line
                        v-if="mode === 'operate'"
                        v-for="(ln, i) in joinHoverLines"
                        :key="'jl'+i"
                        class="floor-join-link"
                        :x1="ln.x1" :y1="ln.y1" :x2="ln.x2" :y2="ln.y2"
                    />

                    <!-- capa mesas -->
                    <g
                        v-for="node in placedNodes"
                        :key="'t'+node.id"
                        class="floor-table"
                        :class="[node.statusClass, { selected: FloorTableIsSelected(node.id), editable: mode === 'edit', parent: node.isParent }]"
                        :transform="`translate(${node.x} ${node.y}) rotate(${node.rotation} ${node.w / 2} ${node.h / 2})`"
                        v-tooltip="mode === 'operate' ? { content: node.tooltip, html: true } : false"
                        @pointerdown.stop="FloorOnTablePointerDown($event, node)"
                        @click.stop="FloorOnTableClick(node)"
                        @pointerenter="hoverJoinId = node.id"
                        @pointerleave="hoverJoinId = null"
                    >
                        <path
                            v-for="(c, i) in node.seats"
                            :key="'ch'+i"
                            class="floor-chair"
                            :d="c.d"
                        />
                        <ellipse v-if="node.shape === 'round'" class="floor-table-body" :cx="node.w / 2" :cy="node.h / 2" :rx="node.w / 2" :ry="node.h / 2"/>
                        <path v-else-if="node.shape === 'diamond'" class="floor-table-body" :d="svgDiamondPath(node.w, node.h)"/>
                        <rect v-else class="floor-table-body" :x="0" :y="0" :width="node.w" :height="node.h" :rx="node.shape === 'square' ? 0.8 : 1.2" :ry="node.shape === 'square' ? 0.8 : 1.2"/>
                        <g v-if="node.isParent || node.statusClass === 'JOINED'" class="floor-table-double">
                            <ellipse v-if="node.shape === 'round'" class="floor-table-inner" :cx="node.w / 2" :cy="node.h / 2" :rx="Math.max(node.w / 2 - 0.75, 0.4)" :ry="Math.max(node.h / 2 - 0.75, 0.4)"/>
                            <path v-else-if="node.shape === 'diamond'" class="floor-table-inner" :d="svgDiamondPath(node.w, node.h, 0.75)"/>
                            <rect v-else class="floor-table-inner" :x="0.75" :y="0.75" :width="node.w - 1.5" :height="node.h - 1.5" :rx="Math.max((node.shape === 'square' ? 0.8 : 1.2) - 0.5, 0)" :ry="Math.max((node.shape === 'square' ? 0.8 : 1.2) - 0.5, 0)"/>
                        </g>
                        <text :x="node.w / 2" :y="node.h / 2" text-anchor="middle" dominant-baseline="middle" class="floor-table-label" :style="{ fontSize: node.nameFont + 'px' }">{{ node.name }}</text>
                        <g v-if="node.prePrintMark" class="floor-table-preprint" :transform="`translate(${node.w / 2} 0) scale(${node.prePrintScale})`">
                            <rect class="floor-table-preprint-pad" :x="node.prePrintMark.padX" :y="-node.prePrintMark.padH / 2" :width="node.prePrintMark.padW" :height="node.prePrintMark.padH" :rx="node.prePrintMark.padH / 2"/>
                            <text class="floor-table-preprint-icon" :x="node.prePrintMark.iconX" y="-0.02" text-anchor="middle" dominant-baseline="central">{{ node.prePrintMark.char }}</text>
                            <text class="floor-table-preprint-time" :x="node.prePrintMark.countX" y="0.12" text-anchor="start" dominant-baseline="central">{{ node.prePrintMark.n }}</text>
                        </g>
                        <g v-if="node.statusMark" class="floor-table-status" :transform="`translate(${node.w / 2} ${node.h}) scale(${node.statusScale})`">
                            <rect class="floor-table-status-pad" :x="node.statusMark.padX" :y="-node.statusMark.padH / 2" :width="node.statusMark.padW" :height="node.statusMark.padH" :rx="node.statusMark.padH / 2"/>
                            <g v-for="ic in node.statusMark.icons" :key="ic.char">
                                <text
                                    class="floor-table-status-icon"
                                    :x="ic.iconX"
                                    y="-0.05"
                                    text-anchor="middle"
                                    dominant-baseline="central"
                                >{{ ic.char }}</text>
                                <text
                                    v-if="ic.n"
                                    class="floor-table-status-count"
                                    :x="ic.countX"
                                    y="0.22"
                                    text-anchor="start"
                                    dominant-baseline="central"
                                >{{ ic.n }}</text>
                            </g>
                        </g>
                    </g>
                    <rect
                        v-if="marqueeBox"
                        class="floor-marquee"
                        :x="marqueeBox.x"
                        :y="marqueeBox.y"
                        :width="marqueeBox.w"
                        :height="marqueeBox.h"
                    />
                    <rect
                        v-if="refMove && refImage"
                        class="floor-ref-hit"
                        x="0" y="0"
                        :width="viewWidth"
                        :height="viewHeight"
                        @pointerdown.stop="FloorOnRefPointerDown"
                    />
                </svg>
                </div>
                </div>
            </div>
        </div>
    </template>

    <script>
    const FLOOR_ICONS = {
        plant: {
            vb: '42 24 158 172',
            d: [
                'M 118.14 32.16 C 119.58 30.45 122.15 31.08 123.45 32.61 C 130.13 38.72 135.55 46.27 139.23 54.53 C 142.27 61.26 142.24 68.84 141.27 76.02 C 146.96 71.45 153.64 67.94 160.92 66.85 C 170.85 65.43 181.07 66.70 190.59 69.78 C 192.45 70.31 191.75 72.50 191.52 73.88 C 189.28 83.32 185.91 92.91 179.22 100.18 C 175.57 104.29 170.93 107.39 165.98 109.72 C 179.79 115.86 188.20 129.85 192.03 143.94 C 192.51 145.79 193.33 148.95 190.88 149.74 C 180.62 152.86 169.51 154.73 158.91 152.11 C 153.43 150.84 148.42 148.15 143.81 144.98 C 145.50 161.23 135.89 176.03 124.18 186.33 C 122.68 187.58 120.63 186.59 119.48 185.36 C 109.52 176.13 100.81 163.97 100.32 149.94 C 99.96 147.01 102.60 144.93 102.72 142.12 C 94.50 151.74 81.01 154.06 68.99 153.22 C 62.83 152.51 56.50 151.70 50.81 149.13 C 50.05 147.57 50.91 145.87 51.17 144.30 C 53.44 135.03 57.42 125.95 64.07 118.97 C 67.43 115.22 71.89 112.79 76.08 110.12 C 70.64 107.45 65.60 103.84 61.79 99.09 C 56.94 93.31 54.03 86.23 51.64 79.15 C 50.78 76.41 49.43 73.74 49.36 70.82 C 51.14 69.01 53.80 68.79 56.12 68.15 C 66.75 65.57 78.34 65.08 88.65 69.25 C 92.87 70.90 96.43 73.79 100.00 76.51 C 98.96 70.23 98.63 63.63 100.65 57.50 C 103.79 47.55 110.56 39.13 118.14 32.16 M 106.32 58.17 C 102.68 68.47 104.38 80.42 110.67 89.34 C 113.03 92.53 115.47 96.19 119.68 97.00 C 117.28 85.23 115.76 72.87 118.85 61.08 C 119.07 60.32 119.86 60.49 120.47 60.46 L 119.35 60.93 C 121.05 71.99 122.77 83.05 124.47 94.12 C 124.59 95.54 125.11 96.87 126.03 97.99 C 125.81 89.08 133.83 83.35 135.66 75.10 C 137.17 69.88 136.58 64.27 134.95 59.16 C 132.16 50.54 126.17 43.49 120.07 36.99 C 115.19 43.83 108.95 49.99 106.32 58.17 M 55.57 73.81 C 57.40 80.05 59.70 86.21 63.32 91.66 C 70.15 102.68 82.97 109.70 95.94 109.38 C 100.50 109.25 105.37 108.75 109.13 105.91 C 97.33 100.14 84.20 95.92 74.99 86.07 C 86.25 91.55 98.09 95.70 109.93 99.73 C 103.86 91.98 99.73 82.32 91.36 76.67 C 80.65 70.08 67.33 71.11 55.57 73.81 M 148.98 76.88 C 140.35 82.08 133.42 91.01 132.26 101.22 C 142.08 93.29 153.53 86.73 166.23 85.12 C 155.39 90.77 145.34 97.77 135.79 105.37 C 142.52 105.27 149.27 104.92 155.97 105.71 C 161.61 106.28 167.09 103.86 171.32 100.28 C 179.15 93.57 183.15 83.63 185.95 73.97 C 173.84 70.66 160.13 70.46 148.98 76.88 M 134.44 113.16 C 137.96 116.08 142.47 117.20 146.45 119.29 C 153.82 122.86 160.57 127.69 166.17 133.68 C 154.89 128.73 143.60 123.80 132.32 118.85 C 135.66 123.52 139.18 128.10 141.82 133.23 C 144.91 139.24 150.45 143.85 156.87 145.93 C 166.58 149.24 177.00 147.55 186.86 146.01 C 185.73 141.00 183.25 136.44 181.02 131.86 C 175.52 121.08 165.03 112.82 152.98 110.92 C 146.79 110.11 140.04 109.99 134.44 113.16 M 72.60 118.66 C 64.01 125.22 59.32 135.50 56.37 145.63 C 68.59 148.91 82.48 149.60 93.71 142.90 C 103.03 137.83 109.21 128.40 111.77 118.27 C 106.47 121.41 101.30 124.76 95.99 127.88 C 90.13 131.33 83.62 133.45 77.10 135.25 C 87.33 128.00 97.99 121.31 107.88 113.61 C 104.28 114.29 100.72 115.42 97.02 115.42 C 92.60 115.57 88.29 114.48 83.97 113.70 C 79.83 114.19 75.99 116.28 72.60 118.66 M 115.22 129.47 C 112.37 136.46 105.74 141.90 105.80 149.98 C 106.59 161.98 114.12 172.32 122.46 180.47 C 130.54 172.60 137.84 162.58 138.51 150.95 C 139.19 140.89 134.06 131.62 127.92 124.06 C 126.94 122.38 125.10 122.04 123.29 122.15 C 125.09 134.41 126.46 147.12 122.92 159.23 C 121.83 146.83 120.18 134.45 117.11 122.37 C 116.71 124.79 116.21 127.21 115.22 129.47 Z',
            ],
        },
        wc: {
            vb: '205 105 390 590',
            d: [
                'M 233.23 124.18 C 241.56 115.92 253.24 111.21 264.97 111.34 C 352.66 111.32 440.36 111.34 528.05 111.33 C 535.78 111.18 543.76 111.22 551.04 114.16 C 567.83 120.27 580.13 137.07 580.40 155.00 C 580.43 191.00 580.38 226.99 580.42 262.98 C 580.66 266.65 578.80 269.99 576.65 272.81 C 571.91 279.08 567.22 285.39 562.46 291.65 C 572.66 291.72 582.53 297.89 586.81 307.18 C 589.85 312.94 589.53 319.62 589.38 325.93 C 588.95 336.08 580.23 345.08 570.09 345.80 C 564.73 346.08 559.37 345.84 554.01 345.93 C 556.64 391.63 559.70 437.31 562.33 483.02 C 562.27 524.60 555.29 566.91 536.80 604.46 C 527.10 624.00 513.88 642.01 497.07 656.03 C 483.34 667.58 467.20 676.18 450.07 681.49 C 428.78 688.09 406.17 689.81 384.01 688.00 C 362.73 686.27 341.63 680.47 322.99 669.92 C 295.46 654.59 274.62 629.16 261.41 600.85 C 244.31 564.49 237.80 523.94 237.61 483.99 C 240.30 437.96 243.34 391.95 246.00 345.91 C 239.12 345.57 232.01 346.81 225.31 344.89 C 219.48 342.97 214.58 338.40 212.22 332.74 C 209.87 327.51 210.57 321.63 210.70 316.08 C 211.73 302.61 224.13 291.60 237.55 291.64 C 231.35 283.59 225.35 275.39 219.23 267.28 C 219.45 265.86 219.62 264.42 219.62 262.98 C 219.59 227.32 219.65 191.66 219.59 156.00 C 219.62 144.14 224.65 132.37 233.23 124.18 M 239.38 147.12 C 237.75 151.20 237.60 155.64 237.68 159.98 C 237.73 191.90 237.62 223.82 237.73 255.74 C 345.93 255.66 454.13 255.73 562.33 255.70 C 562.21 222.15 562.37 188.58 562.25 155.03 C 561.84 141.38 549.61 129.51 535.95 129.48 C 445.60 129.40 355.25 129.45 264.90 129.46 C 253.79 129.27 243.11 136.67 239.38 147.12 M 246.76 273.75 C 251.25 279.77 255.76 285.78 260.25 291.80 C 353.41 291.76 446.58 291.76 539.75 291.80 C 544.19 285.74 548.80 279.80 553.26 273.75 C 451.10 273.79 348.93 273.79 246.76 273.75 M 228.89 316.99 C 228.50 319.64 228.49 322.36 228.80 325.02 C 228.96 327.07 231.17 328.01 232.98 327.80 C 344.35 327.79 455.72 327.81 567.09 327.79 C 569.04 328.13 570.51 326.87 571.42 325.28 C 571.26 322.52 571.50 319.73 571.11 316.99 C 570.36 312.83 566.25 309.68 562.05 309.83 C 454.00 309.84 345.94 309.82 237.88 309.85 C 233.69 309.71 229.62 312.82 228.89 316.99 M 264.22 345.87 C 263.08 364.14 262.00 382.41 260.84 400.68 C 260.13 401.00 258.70 401.65 257.99 401.98 L 260.91 401.17 C 258.99 428.11 257.58 455.08 255.83 482.02 C 255.49 497.69 257.07 513.36 259.41 528.84 C 263.18 552.75 269.85 576.37 280.80 598.02 C 288.55 613.20 298.63 627.32 311.29 638.78 C 325.54 651.92 343.22 661.18 361.97 665.98 C 381.83 671.03 402.68 671.65 422.95 669.00 C 445.79 665.80 467.98 656.67 485.56 641.59 C 509.89 620.95 524.82 591.40 533.46 561.15 C 540.67 535.79 544.14 509.39 544.22 483.05 C 541.48 437.32 538.54 391.61 535.81 345.88 C 445.28 345.94 354.75 345.96 264.22 345.87 Z',
                'M 390.42 165.46 C 400.24 165.44 410.07 165.35 419.89 165.50 C 433.47 166.15 445.16 178.37 445.14 191.98 C 445.77 205.82 434.19 218.68 420.37 219.58 C 410.57 219.84 400.75 219.66 390.94 219.68 C 382.97 219.67 375.13 215.97 370.07 209.81 C 362.32 200.79 361.81 186.48 368.86 176.91 C 373.74 169.99 381.93 165.54 390.42 165.46 M 387.37 184.43 C 384.41 185.70 382.18 188.74 382.14 191.99 C 381.57 196.91 385.97 201.63 390.91 201.45 C 399.96 201.51 409.00 201.45 418.05 201.49 C 422.55 201.60 426.82 197.66 426.89 193.11 C 427.48 188.18 422.96 183.46 418.05 183.66 C 410.34 183.59 402.64 183.67 394.93 183.62 C 392.40 183.66 389.74 183.39 387.37 184.43 Z',
                'M 350.93 368.06 C 374.99 363.42 399.69 363.21 424.08 364.71 C 445.53 366.49 467.58 370.39 486.17 381.86 C 500.50 390.51 511.25 404.41 516.87 420.11 C 524.01 438.86 525.62 459.14 526.19 479.03 C 526.98 504.27 524.62 529.72 517.75 554.06 C 512.88 571.52 505.63 588.42 495.38 603.41 C 484.98 618.54 471.23 631.61 454.82 640.02 C 435.92 649.93 414.16 653.47 392.98 652.40 C 372.71 651.54 352.48 645.69 335.55 634.37 C 321.09 624.72 309.18 611.50 300.27 596.63 C 290.16 579.83 283.42 561.17 279.24 542.06 C 273.87 517.79 272.79 492.76 274.26 468.00 C 275.19 450.74 277.68 433.34 284.17 417.22 C 288.41 407.72 293.82 398.59 301.47 391.43 C 314.86 378.45 332.93 371.66 350.93 368.06 M 337.96 390.00 C 325.10 394.31 313.43 402.46 305.79 413.77 C 293.95 433.64 292.47 457.45 291.88 480.01 C 291.03 511.05 295.12 542.72 307.74 571.31 C 315.87 589.68 328.06 606.75 344.78 618.20 C 359.42 628.48 377.22 633.73 395.02 634.35 C 414.89 635.29 435.36 631.02 452.23 620.20 C 468.10 610.26 480.21 595.22 488.72 578.72 C 498.50 559.55 503.99 538.42 506.59 517.13 C 508.85 496.83 508.62 476.29 506.73 455.98 C 505.15 440.17 501.37 424.11 492.19 410.88 C 484.56 401.06 473.86 394.05 462.21 389.93 C 443.21 383.52 422.93 382.29 403.01 381.96 C 381.17 382.06 358.82 382.83 337.96 390.00 Z',
                'M 381.50 403.28 C 395.52 398.08 411.59 399.12 424.85 406.02 C 438.31 412.97 448.68 425.76 452.40 440.48 C 455.40 451.84 454.55 464.18 449.96 475.01 C 443.14 491.60 427.53 504.22 409.86 507.38 C 398.57 509.35 386.57 507.98 376.30 502.77 C 362.40 496.13 351.69 483.17 347.75 468.28 C 343.84 454.03 345.98 438.01 354.12 425.59 C 360.25 415.26 370.28 407.42 381.50 403.28 M 388.00 420.10 C 377.59 423.59 369.34 432.39 365.84 442.71 C 363.07 450.67 363.37 459.61 366.50 467.42 C 369.51 475.37 375.73 481.85 383.08 485.98 C 391.86 490.69 402.63 491.47 412.01 488.12 C 420.11 485.42 426.84 479.43 431.22 472.19 C 436.18 463.57 437.47 452.88 434.41 443.40 C 431.08 432.57 422.34 423.66 411.68 419.90 C 406.67 418.14 401.31 418.16 396.08 417.84 C 393.40 418.63 390.63 419.15 388.00 420.10 Z',
            ],
        },
    };
    // FloorMap vive en un solo archivo: el pointer (drag, marquee, dibujo de paredes)
    // comparte estado con el SVG. No extraer a otros módulos.
    // Secciones: constantes → geom pura → instancia Vue → estilos.

    // --- Constantes: unidades del viewBox (16:10), no píxeles de pantalla ---
    const SVG_VIEW_W = 160;
    const SVG_VIEW_H = 100;
    const SVG_GRID = 5;
    const FLOOR_SIZE_K = { min: 10, max: 40, step: 5 };
    const FLOOR_SIZE_PRESETS = [
        { key: 'xsmall', label: 'XS', title: 'Salón pequeño', w: 80, h: 50 },
        { key: 'normal', label: 'S', title: 'Salón normal', w: 160, h: 100 },
        { key: 'large', label: 'M', title: 'Salón grande', w: 240, h: 150 },
        { key: 'xlarge', label: 'L', title: 'Salón muy grande', w: 320, h: 200 },
    ];
    const SVG_SIZE = { min: 5, max: 20, step: 5 }; // 1–4 celdas (1 celda = 1 m)
    const SVG_RECT_ASPECT = 1.5;
    const SVG_RECT_MIN = { w: 10, h: 5 }; // 2 celdas; las otras formas sí bajan a 1×1
    const SVG_SHAPE_SIZE = {
        round:   { w: 10, h: 10 },
        square:  { w: 10, h: 10 },
        diamond: { w: 10, h: 10 },
        rect:    { w: 15, h: 10 },
    };
    const SVG_LABEL_SIZE = { w: 15, h: 10 };
    const SVG_LABEL_TEXT_MAX = 60; 
    const SVG_LABEL_FONT = { min: 1.4, max: 5.4, def: 2.2 };
    const SVG_STAIRS_SIZE = { w: 10, h: 10 };
    const SVG_STAIRS = { min: 5, max: 25, step: 5 }; // 1×1 a 5×5 celdas
    const SVG_COLUMN_SIZE = { w: 5, h: 5 };
    const SEGMENT_TYPES = ['wall', 'door', 'window'];
    const STAMP_TYPES = ['stairs', 'column', 'plant', 'toilet'];
    const SEGMENT_PREFIX = { wall: 'w', door: 'd', window: 'win' };
    const DOOR_DIRS = [
        [1, 0], [1, 1], [0, 1], [-1, 1],
        [-1, 0], [-1, -1], [0, -1], [1, -1],
    ];
    const FLOOR_TOOL_LABELS = {
        select: 'Seleccionar',
        wall: 'Pared',
        window: 'Ventana',
        door: 'Puerta',
        stairs: 'Escalera',
        column: 'Pilar',
        plant: 'Planta',
        toilet: 'Inodoro',
        label: 'Texto',
        ref: 'Imagen de referencia',
    };

    // --- Geom pura (sin Vue): snap, colisiones, paths de puerta/ventana/sillas ---
    const svgClamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const svgSnapGrid = (v) => Math.round(v / SVG_GRID) * SVG_GRID;
    const svgSnapCell = (v) => Math.floor(v / SVG_GRID) * SVG_GRID;
    const svgOnGrid = (v) => Math.abs(Number(v) - svgSnapGrid(Number(v))) < 0.01;
    const svgBoxOnGrid = (d) => d && d.x != null && svgOnGrid(d.x) && svgOnGrid(d.y) && svgOnGrid(d.w) && svgOnGrid(d.h);
    const MARQUEE_MIN = 1.5;

    // Caja AABB desde dos esquinas (el marquee se dibuja en cualquier dirección).
    function svgNormRect(x1, y1, x2, y2) {
        return { x: Math.min(x1, x2), y: Math.min(y1, y2), w: Math.abs(x2 - x1), h: Math.abs(y2 - y1) };
    }
    // Intersección de cajas (como Windows: alcanza con tocar, no hace falta contener).
    function svgRectsHit(a, b) {
        return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
    }
    // Segmento vs rect (Liang-Barsky). Evita que un cuarto cerrado seleccione la pared al marcar adentro.
    function svgSegHitsRect(p1, p2, r) {
        let dx = p2.x - p1.x, dy = p2.y - p1.y, t0 = 0, t1 = 1;
        const clip = (p, q) => {
            if(Math.abs(p) < 1e-9) return q >= 0;
            const t = q / p;
            if(p < 0) { if(t > t1) return false; if(t > t0) t0 = t; }
            else { if(t < t0) return false; if(t < t1) t1 = t; }
            return true;
        };
        return clip(-dx, p1.x - r.x) && clip(dx, r.x + r.w - p1.x)
            && clip(-dy, p1.y - r.y) && clip(dy, r.y + r.h - p1.y);
    }
    function svgMarqueeHits(el, r) {
        if(el.type === 'wall' || (el.points && el.points.length)) {
            if(!svgRectsHit(r, svgWallBox(el))) return false;
            const pts = svgWallPoints(el);
            for(let i = 1; i < pts.length; i++) {
                if(svgSegHitsRect(pts[i - 1], pts[i], r)) return true;
            }
            return !!(el.closed && pts.length >= 2 && svgSegHitsRect(pts[pts.length - 1], pts[0], r));
        }
        return svgRectsHit(r, svgItemBox(el));
    }
    // Caja de hit de mesa/sello/zona, polígono de pared o segmento (puerta/ventana).
    function svgWallPoints(el) {
        if(!el.points || !el.points.length) return [];
        return el.points.map(p => ({ x: Number(p.x), y: Number(p.y) }));
    }
    function svgWallPath(el) {
        const pts = svgWallPoints(el);
        if(pts.length < 2) return '';
        let d = 'M ' + pts[0].x + ' ' + pts[0].y;
        for(let i = 1; i < pts.length; i++) d += ' L ' + pts[i].x + ' ' + pts[i].y;
        if(el.closed) d += ' Z';
        return d;
    }
    function svgWallBox(el) {
        const pts = svgWallPoints(el);
        if(!pts.length) return { x: 0, y: 0, w: 0, h: 0 };
        let minX = pts[0].x, maxX = pts[0].x, minY = pts[0].y, maxY = pts[0].y;
        pts.forEach(p => {
            if(p.x < minX) minX = p.x;
            if(p.x > maxX) maxX = p.x;
            if(p.y < minY) minY = p.y;
            if(p.y > maxY) maxY = p.y;
        });
        return { x: minX, y: minY, w: Math.max(maxX - minX, 0.6), h: Math.max(maxY - minY, 0.6) };
    }
    function svgElementOnGrid(el) {
        if(!el) return false;
        if(el.type === 'wall' || (el.points && el.points.length)) {
            const pts = svgWallPoints(el);
            return pts.length >= 2 && pts.every(p => svgOnGrid(p.x) && svgOnGrid(p.y));
        }
        if(el.x1 != null) return svgOnGrid(el.x1) && svgOnGrid(el.y1) && svgOnGrid(el.x2) && svgOnGrid(el.y2);
        if(el.type === 'stairs') return svgBoxOnGrid(el) && Math.abs(el.w - el.h) < 0.01;
        return svgBoxOnGrid(el);
    }
    function svgItemBox(el) {
        if(el.type === 'wall' || (el.points && el.points.length)) return svgWallBox(el);
        if(el.x1 != null) {
            return {
                x: Math.min(el.x1, el.x2),
                y: Math.min(el.y1, el.y2),
                w: Math.max(Math.abs(el.x2 - el.x1), 0.6),
                h: Math.max(Math.abs(el.y2 - el.y1), 0.6),
            };
        }
        return { x: el.x, y: el.y, w: el.w, h: el.h };
    }

    function svgNormalizeDims(shape, w, h) {
        if(shape === 'rect') {
            const ratio = (w && h) ? w / h : SVG_RECT_ASPECT;
            let nh = svgClamp(svgSnapGrid(h || SVG_SHAPE_SIZE.rect.h), SVG_SIZE.min, SVG_SIZE.max);
            let nw = svgClamp(svgSnapGrid(nh * ratio), SVG_SIZE.min, SVG_SIZE.max);
            if(nw >= SVG_SIZE.max) { nw = SVG_SIZE.max; nh = svgClamp(svgSnapGrid(nw / ratio), SVG_RECT_MIN.h, SVG_SIZE.max); }
            else if(nw <= SVG_RECT_MIN.w) { nw = SVG_RECT_MIN.w; nh = svgClamp(svgSnapGrid(nw / ratio), SVG_RECT_MIN.h, SVG_SIZE.max); }
            if(nw < SVG_RECT_MIN.w || nh < SVG_RECT_MIN.h) return { w: SVG_RECT_MIN.w, h: SVG_RECT_MIN.h };
            return { w: nw, h: nh };
        }
        const s = svgClamp(svgSnapGrid(Math.max(w || 0, h || 0, SVG_SIZE.min)), SVG_SIZE.min, SVG_SIZE.max);
        return { w: s, h: s };
    }

    function svgClampInView(d, vw, vh) {
        d.x = svgClamp(svgSnapGrid(d.x), 0, Math.max(0, vw - d.w));
        d.y = svgClamp(svgSnapGrid(d.y), 0, Math.max(0, vh - d.h));
    }
    // Mismo dx/dy para todos los puntos: el grupo no se deforma al pegar el borde.
    function svgFitDelta(dx, dy, pts, vw, vh) {
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        (pts || []).forEach(p => {
            if(p.x < minX) minX = p.x;
            if(p.x > maxX) maxX = p.x;
            if(p.y < minY) minY = p.y;
            if(p.y > maxY) maxY = p.y;
        });
        if(minX === Infinity) return { dx: 0, dy: 0 };
        return {
            dx: svgClamp(dx, -minX, vw - maxX),
            dy: svgClamp(dy, -minY, vh - maxY),
        };
    }

    function svgPlaceAtCenter(d, cx, cy, vw, vh) {
        d.x = cx - d.w / 2;
        d.y = cy - d.h / 2;
        svgClampInView(d, vw, vh);
    }

    function svgCanResize(d, direction = 1) {
        const range = d.type === 'stairs' ? SVG_STAIRS : SVG_SIZE;
        const shape = d.shape || 'round';
        if(shape === 'rect' || shape === 'text') {
            const minW = d.type === 'label' ? range.min : SVG_RECT_MIN.w;
            const minH = d.type === 'label' ? range.min : SVG_RECT_MIN.h;
            const max = d.type === 'label' && shape === 'text' ? SVG_LABEL_TEXT_MAX : range.max;
            const ratio = d.w / d.h || SVG_RECT_ASPECT;
            const nextH = svgSnapGrid(d.h + direction * range.step);
            const nextW = svgSnapGrid(nextH * ratio);
            if(direction < 0) return nextH >= minH && nextW >= minW;
            return nextH <= max && nextW <= max;
        }
        const s = Math.max(d.w, d.h) + direction * range.step;
        return direction < 0 ? s >= range.min : s <= range.max;
    }
    // Botones +/− de la barra: un solo lugar en vez de 3 computeds (mesa / zona / sello).
    function svgResizeBtns(d) {
        if(!d) return { up: false, down: false };
        return { up: svgCanResize(d, 1), down: svgCanResize(d, -1) };
    }

    // Fuente que entra en w×h (viewBox). 0.62 ≈ ancho de un glifo bold.
    function floorFitFont(text, w, h, maxFont) {
        const n = String(text || '');
        const maxW = Math.max(w - 1.4, 2);
        const maxH = Math.max(Math.min(h - 1.2, h * 0.55), 1.2);
        const byW = n.length ? maxW / (n.length * 0.62) : maxFont;
        return Math.max(1.2, Math.min(maxFont, maxH, byW));
    }
    // \ue047 = icon-check, \ue093 = icon-spatula (influye-font).
    function floorStatusMark(table) {
        const items = [];
        const ready = table.items && table.items.ready;
        const pending = table.items && table.items.pending;
        if(ready) items.push({ char: '\ue047', n: String(ready) });
        else if(table.status === 'READY') items.push({ char: '\ue047', n: '' });
        if(pending) items.push({ char: '\ue093', n: String(pending) });
        else if(table.status === 'PENDING' && !items.length) items.push({ char: '\ue093', n: '' });
        if(!items.length) return null;
        const iconW = 2.2;
        const pairGap = 0.7;
        const groupGap = 2.2;
        const side = 1.4;
        const digitW = 1.15;
        const padH = 3.6;
        const groupW = it => iconW + (it.n ? pairGap + it.n.length * digitW : 0);
        const inner = items.reduce((s, it, i) => s + groupW(it) + (i ? groupGap : 0), 0);
        const padW = Math.max(padH, inner + side * 2);
        let x = -inner / 2;
        const icons = items.map(it => {
            const iconX = x + iconW / 2;
            const countX = x + iconW + pairGap;
            x += groupW(it) + groupGap;
            return { char: it.char, n: it.n, iconX, countX };
        });
        return { icons, padX: -padW / 2, padW, padH };
    }
    // Pre cuenta: misma pastilla, más chica, para ir arriba de la mesa.
    function floorPrePrintMark(table) {
        if(!table.last_pre_print || !table.last_pre_print.time) return null;
        const iconW = 1.45;
        const pairGap = 0.35;
        const side = 0.7;
        const digitW = 0.78;
        const padH = 2.15;
        const n = String(table.last_pre_print.time);
        const inner = iconW + pairGap + n.length * digitW;
        const padW = Math.max(padH, inner + side * 2);
        return {
            char: '\ue094',
            n,
            iconX: -inner / 2 + iconW / 2,
            countX: -inner / 2 + iconW + pairGap,
            padX: -padW / 2,
            padW,
            padH,
        };
    }
    function newElementId(prefix) {
        return prefix + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    }

    // Símbolo puerta
    // Se dibuja en unidades del mapa para que el trazo se vea a cualquier tamaño de vano.
    function svgDoorGeom(x1, y1, x2, y2, flip) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const r = Math.hypot(dx, dy);
        if(r < 0.01) return null;
        const ox = flip ? x1 + dy : x1 - dy;
        const oy = flip ? y1 - dx : y1 + dx;
        const frame = `M ${x2} ${y2} L ${x1} ${y1} L ${ox} ${oy}`;
        const sweep = flip ? 0 : 1;
        const arc = `M ${x2} ${y2} A ${r} ${r} 0 0 ${sweep} ${ox} ${oy}`;
        return { frame, arc, r, ox, oy };
    }

    // Ventana: doble línea paralela al vano (sin SVG; estilo de segmento).
    function svgWindowGeom(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.hypot(dx, dy);
        if(len < 0.01) return null;
        const o = 0.7;
        const nx = (-dy / len) * o;
        const ny = (dx / len) * o;
        const a = { x1: x1 + nx, y1: y1 + ny, x2: x2 + nx, y2: y2 + ny };
        const b = { x1: x1 - nx, y1: y1 - ny, x2: x2 - nx, y2: y2 - ny };
        return {
            a,
            b,
            fill: `M ${a.x1} ${a.y1} L ${a.x2} ${a.y2} L ${b.x2} ${b.y2} L ${b.x1} ${b.y1} Z`,
        };
    }

    function stairsNormRot(r) {
        return ((Number(r) || 0) % 360 + 360) % 360;
    }
    function stairsStepLines(w, h, rot) {
        const r = stairsNormRot(rot);
        const side = r === 90 || r === 270;
        const n = 4;
        const lines = [];
        for(let i = 1; i <= n; i++) {
            if(side) {
                const x = (w * i) / (n + 1);
                lines.push({ x1: x, y1: 0, x2: x, y2: h });
            } else {
                const y = (h * i) / (n + 1);
                lines.push({ x1: 0, y1: y, x2: w, y2: y });
            }
        }
        return lines;
    }
    function stairsArrowPath(w, h, rot) {
        const r = stairsNormRot(rot);
        const cx = w / 2;
        const cy = h / 2;
        const wing = Math.min(w, h) * 0.18;
        if(r === 90) {
            const left = w * 0.18;
            const right = w * 0.88;
            return `M ${left} ${cy} L ${right} ${cy} M ${right - wing} ${cy - wing} L ${right} ${cy} L ${right - wing} ${cy + wing}`;
        }
        if(r === 270) {
            const left = w * 0.18;
            const right = w * 0.88;
            return `M ${right} ${cy} L ${left} ${cy} M ${left + wing} ${cy - wing} L ${left} ${cy} L ${left + wing} ${cy + wing}`;
        }
        if(r === 180) {
            const top = h * 0.18;
            const bot = h * 0.88;
            return `M ${cx} ${top} L ${cx} ${bot} M ${cx - wing} ${bot - wing} L ${cx} ${bot} L ${cx + wing} ${bot - wing}`;
        }
        const top = h * 0.18;
        const bot = h * 0.88;
        return `M ${cx} ${bot} L ${cx} ${top} M ${cx - wing} ${top + wing} L ${cx} ${top} L ${cx + wing} ${top + wing}`;
    }

    function svgDiamondPath(w, h, inset) {
        const i = Number(inset) || 0;
        return `M ${w / 2} ${i} L ${w - i} ${h / 2} L ${w / 2} ${h - i} L ${i} ${h / 2} Z`;
    }

    /** Sillas = trazo siguiendo el borde (arco en round, recta en rect/square). */
    function svgChairPositions(shape, w, h, n) {
        const count = Math.max(0, Math.min(12, Math.floor(Number(n) || 0)));
        if(count <= 0) return [];
        const cx = w / 2;
        const cy = h / 2;
        const offset = 0.7;
        const fill = 0.55;
        // tope de largo visual: con n=1 el slot es enorme y la silla se ve como medio anillo
        const maxAngle = 0.9; // ~52°
        const maxLen = Math.min(w, h) * 0.4;
        const out = [];

        if(shape === 'round') {
            const rx = w / 2 + offset;
            const ry = h / 2 + offset;
            const slot = (2 * Math.PI) / count;
            const span = Math.min(slot * fill, maxAngle);
            const half = span / 2;
            const large = span > Math.PI ? 1 : 0;
            for(let i = 0; i < count; i++) {
                const mid = -Math.PI / 2 + i * slot;
                const a0 = mid - half;
                const a1 = mid + half;
                const x0 = cx + Math.cos(a0) * rx;
                const y0 = cy + Math.sin(a0) * ry;
                const x1 = cx + Math.cos(a1) * rx;
                const y1 = cy + Math.sin(a1) * ry;
                out.push({ d: `M ${x0} ${y0} A ${rx} ${ry} 0 ${large} 1 ${x1} ${y1}` });
            }
            return out;
        }

        if(shape === 'diamond') {
            const verts = [
                { x: w / 2, y: 0 },
                { x: w, y: h / 2 },
                { x: w / 2, y: h },
                { x: 0, y: h / 2 },
            ];
            const base = Math.floor(count / 4);
            const extra = count % 4;
            for(let s = 0; s < 4; s++) {
                const nSide = base + (s < extra ? 1 : 0);
                if(nSide <= 0) continue;
                const a = verts[s];
                const b = verts[(s + 1) % 4];
                const dx = b.x - a.x;
                const dy = b.y - a.y;
                const len = Math.hypot(dx, dy) || 1;
                const ux = dx / len;
                const uy = dy / len;
                let nx = uy;
                let ny = -ux;
                const midX = (a.x + b.x) / 2;
                const midY = (a.y + b.y) / 2;
                if((midX - cx) * nx + (midY - cy) * ny < 0) {
                    nx = -nx;
                    ny = -ny;
                }
                const inset = len * 0.08;
                const usable = Math.max(0.5, len - 2 * inset);
                const slot = usable / nSide;
                const chairLen = Math.min(slot * fill, maxLen, usable * 0.9);
                const half = chairLen / 2;
                for(let i = 0; i < nSide; i++) {
                    const t = inset + slot * (i + 0.5);
                    const px = a.x + ux * t;
                    const py = a.y + uy * t;
                    out.push({
                        d: `M ${px - ux * half + nx * offset} ${py - uy * half + ny * offset} L ${px + ux * half + nx * offset} ${py + uy * half + ny * offset}`,
                    });
                }
            }
            return out;
        }

        // rect/square: segmentos rectos paralelos a cada lado
        const sides = [
            { len: w, at: (t, half) => ({ x1: t - half, y1: -offset, x2: t + half, y2: -offset }) },
            { len: h, at: (t, half) => ({ x1: w + offset, y1: t - half, x2: w + offset, y2: t + half }) },
            { len: w, at: (t, half) => ({ x1: w - (t - half), y1: h + offset, x2: w - (t + half), y2: h + offset }) },
            { len: h, at: (t, half) => ({ x1: -offset, y1: h - (t - half), x2: -offset, y2: h - (t + half) }) },
        ];
        const base = Math.floor(count / 4);
        const extra = count % 4;
        for(let s = 0; s < 4; s++) {
            const nSide = base + (s < extra ? 1 : 0);
            if(nSide <= 0) continue;
            const side = sides[s];
            const inset = side.len * 0.08;
            const usable = Math.max(0.5, side.len - 2 * inset);
            const slot = usable / nSide;
            const chairLen = Math.min(slot * fill, maxLen, usable * 0.9);
            const half = chairLen / 2;
            for(let i = 0; i < nSide; i++) {
                const t = inset + slot * (i + 0.5);
                const p = side.at(t, half);
                out.push({ d: `M ${p.x1} ${p.y1} L ${p.x2} ${p.y2}` });
            }
        }
        return out;
    }

    export default {
        name: 'FloorMap',
        // Draft de layout/elementos + pointer. Las barras y el SVG solo leen computed.
        props: {
            tables: { type: Array, default: () => [] },
            elements: { type: Array, default: () => [] },
            mode: { type: String, default: 'operate' },
            viewWidth: { type: Number, default: SVG_VIEW_W },
            viewHeight: { type: Number, default: SVG_VIEW_H },
            refSession: { type: Object, default: null },
            unplacedOpen: { type: Boolean, default: false },
            unplacedDisabled: { type: Boolean, default: false },
        },
        data() {
            const session = this.refSession;
            const hasRef = !!(session && session.url);
            return {
                gridSize: SVG_GRID,
                layoutDraft: {},
                elementsDraft: [],
                dirty: false,
                selectedTableIds: [],
                selectedElementIds: [],
                marquee: null,
                drag: null,
                tool: 'select',
                lineDraft: null,
                pathDraft: null,
                toolbarsDimmed: false,
                pendingLabelText: 'Cocina',
                labelPresets: ['Cocina', 'Barra', 'Baño'],
                lastTableSize: null,
                hoverJoinId: null,
                refImage: hasRef ? session.url : null,
                ref: hasRef
                    ? { x: session.x || 0, y: session.y || 0, scale: session.scale || 1 }
                    : { x: 0, y: 0, scale: 1 },
                refMove: false,
                // Constante en data para que el template la vea (Vue 2 no lee consts del script).
                sizePresets: FLOOR_SIZE_PRESETS,
                iconPlant: FLOOR_ICONS.plant,
                iconWc: FLOOR_ICONS.wc,
            };
        },
        computed: {
            currentSizeKey() {
                const p = FLOOR_SIZE_PRESETS.find(s => s.w === this.viewWidth && s.h === this.viewHeight);
                return p ? p.key : null;
            },
            sizeNudge() {
                const k = Math.round(this.viewWidth / 8);
                const downK = k - FLOOR_SIZE_K.step;
                const upK = k + FLOOR_SIZE_K.step;
                const down = { w: downK * 8, h: downK * 5 };
                const box = this.FloorContentMax();
                return {
                    down: downK >= FLOOR_SIZE_K.min && box.maxX <= down.w && box.maxY <= down.h,
                    up: upK <= FLOOR_SIZE_K.max,
                };
            },
            refBox() {
                return {
                    x: this.ref.x,
                    y: this.ref.y,
                    w: this.viewWidth * this.ref.scale,
                    h: this.viewHeight * this.ref.scale,
                };
            },
            // Un solo ítem → id suelto para la barra de props. Varios → isMultiSelect.
            selectedTableId: {
                get() {
                    return this.selectedTableIds.length === 1 && !this.selectedElementIds.length ? this.selectedTableIds[0] : null;
                },
                set(id) {
                    this.selectedTableIds = id == null ? [] : [id];
                    if(id != null) this.selectedElementIds = [];
                },
            },
            selectedElementId: {
                get() {
                    return this.selectedElementIds.length === 1 && !this.selectedTableIds.length ? this.selectedElementIds[0] : null;
                },
                set(id) {
                    this.selectedElementIds = id == null ? [] : [id];
                    if(id != null) this.selectedTableIds = [];
                },
            },
            isMultiSelect() {
                return this.selectedTableIds.length + this.selectedElementIds.length > 1;
            },
            marqueeBox() {
                return this.marquee ? svgNormRect(this.marquee.x1, this.marquee.y1, this.marquee.x2, this.marquee.y2) : null;
            },
            unplacedTables() {
                return this.tables.filter(t => {
                    const raw = this.FloorGetLayout(t);
                    return !raw || raw.x == null;
                });
            },
            selectedShape() {
                const d = this.layoutDraft[this.selectedTableId];
                return (d && d.shape) || 'round';
            },
            // Elemento del plano seleccionado (zona / sello / segmento). El kind decide la barra derecha.
            selectedEl() {
                if(!this.selectedElementId) return null;
                return this.elementsDraft.find(e => e.id === this.selectedElementId) || null;
            },
            selectedKind() {
                const e = this.selectedEl;
                if(!e) return null;
                if(e.type === 'label') return 'label';
                if(STAMP_TYPES.indexOf(e.type) !== -1) return 'stamp';
                if(SEGMENT_TYPES.indexOf(e.type) !== -1) return 'segment';
                return e.type;
            },
            // Preview al arrastrar puerta/ventana (mismo geom que el elemento ya guardado).
            lineDraftGeom() {
                const d = this.lineDraft;
                if(!d || (d.type !== 'door' && d.type !== 'window')) return null;
                if(Math.abs(d.x2 - d.x1) < 0.5 && Math.abs(d.y2 - d.y1) < 0.5) return null;
                return d.type === 'door'
                    ? svgDoorGeom(d.x1, d.y1, d.x2, d.y2, d.flip)
                    : svgWindowGeom(d.x1, d.y1, d.x2, d.y2);
            },
            // Un pass sobre LiveElements: puertas/ventanas salen con .geom para el <path>.
            liveByType() {
                const by = { wall: [], window: [], door: [], stairs: [], column: [], plant: [], toilet: [], label: [] };
                this.LiveElements().forEach(e => {
                    if(e.type === 'door') {
                        const geom = svgDoorGeom(e.x1, e.y1, e.x2, e.y2, e.flip);
                        if(geom) by.door.push(Object.assign({}, e, { geom }));
                    } else if(e.type === 'window') {
                        const geom = svgWindowGeom(e.x1, e.y1, e.x2, e.y2);
                        if(geom) by.window.push(Object.assign({}, e, { geom }));
                    } else if(e.type === 'wall') {
                        const d = svgWallPath(e);
                        if(d) by.wall.push(Object.assign({}, e, { d }));
                    } else if(by[e.type]) {
                        by[e.type].push(e);
                    }
                });
                return by;
            },
            placedNodes() {
                // Arma un objeto con lo que el dibujo necesita: posición, tamaño, forma, rotación, estado, tooltip, la pastilla de check o espátula, la de pre cuenta y el tamaño del nombre.
                return this.tables
                    .map(table => {
                        const raw = this.FloorGetLayout(table);
                        if(!raw || raw.x == null) return null;
                        const dims = svgNormalizeDims(raw.shape || 'round', raw.w, raw.h);
                        const shape = raw.shape || 'round';
                        const statusClass = table.status || this.FloorResolveStatus(table);
                        const seatCount = this.mode === 'edit' || statusClass === 'AVAILABLE' ? (Number(table.seats) || 0) : 0;
                        const statusMark = floorStatusMark(table);
                        const statusScale = statusMark
                            ? Math.min(1, dims.w / statusMark.padW, (dims.h * 0.42) / statusMark.padH)
                            : 1;
                        const prePrintMark = floorPrePrintMark(table);
                        const prePrintScale = prePrintMark
                            ? Math.min(1, dims.w / prePrintMark.padW, (dims.h * 0.28) / prePrintMark.padH)
                            : 1;
                            
                        return {
                            id: table.id,
                            name: table.name,
                            table,
                            x: Number(raw.x),
                            y: Number(raw.y),
                            w: Number(dims.w),
                            h: Number(dims.h),
                            shape,
                            rotation: Number(raw.rotation || 0),
                            statusClass,
                            tooltip: this.FloorBuildTableTooltip(table),
                            statusMark,
                            statusScale,
                            prePrintMark,
                            prePrintScale,
                            isParent: !table.parent_table && this.tables.some(t => t.parent_table === table.name),
                            seats: svgChairPositions(shape, dims.w, dims.h, seatCount),
                            nameFont: floorFitFont(table.name, dims.w, dims.h, 3.2),
                        };
                    })
                    .filter(Boolean);
            },
            joinHoverLines() {
                if(this.mode === 'edit' || this.hoverJoinId == null) return [];
                const nodes = this.placedNodes;
                const hover = nodes.find(n => n.id === this.hoverJoinId);
                if(!hover) return [];
                const parentName = hover.table.parent_table || (hover.isParent ? hover.name : null);
                if(!parentName) return [];
                const parent = nodes.find(n => n.name === parentName);
                if(!parent) return [];
                return nodes
                    .filter(n => n.table.parent_table === parentName)
                    .map(kid => ({
                        x1: parent.x + parent.w / 2,
                        y1: parent.y + parent.h / 2,
                        x2: kid.x + kid.w / 2,
                        y2: kid.y + kid.h / 2,
                    }));
            },
        },
        watch: {
            tables: {
                deep: true,
                handler() {
                    if(this.mode === 'operate' || !this.dirty) this.FloorSyncFromProps();
                },
            },
            elements: {
                deep: true,
                handler() {
                    if(this.mode === 'operate' || !this.dirty) this.FloorSyncElementsFromProps();
                },
            },
            tool(next, prev) {
                if(prev === 'wall' && next !== 'wall') this.FloorFinishWallPath();
            },
        },
        mounted() {
            this.FloorSyncFromProps();
            this.FloorSyncElementsFromProps();
            window.addEventListener('pointermove', this.FloorOnPointerMove);
            window.addEventListener('pointerup', this.FloorOnPointerUp);
            window.addEventListener('pointercancel', this.FloorOnPointerUp);
            window.addEventListener('keydown', this.FloorOnKeyDown);
        },
        beforeDestroy() {
            window.removeEventListener('pointermove', this.FloorOnPointerMove);
            window.removeEventListener('pointerup', this.FloorOnPointerUp);
            window.removeEventListener('pointercancel', this.FloorOnPointerUp);
            window.removeEventListener('keydown', this.FloorOnKeyDown);
        },
        methods: {
            // Pointer y persistencia. La geom (svgDoorGeom, sillas, snap) está arriba, sin this.
            SvgClientToLocal(clientX, clientY) {
                const svg = this.$refs.stage && this.$refs.stage.querySelector('.floor-map-svg');
                if(!svg) return { x: 0, y: 0 };
                const pt = svg.createSVGPoint();
                pt.x = clientX;
                pt.y = clientY;
                const ctm = svg.getScreenCTM();
                if(!ctm) return { x: 0, y: 0 };
                const local = pt.matrixTransform(ctm.inverse());
                return { x: local.x, y: local.y };
            },
            FloorContentMax() {
                let maxX = 0;
                let maxY = 0;
                Object.keys(this.layoutDraft).forEach(id => {
                    const d = this.layoutDraft[id];
                    if(!d || d.x == null) return;
                    maxX = Math.max(maxX, Number(d.x) + Number(d.w || 0));
                    maxY = Math.max(maxY, Number(d.y) + Number(d.h || 0));
                });
                this.LiveElements().forEach(el => {
                    if(el.type === 'wall' || (el.points && el.points.length)) {
                        svgWallPoints(el).forEach(p => {
                            maxX = Math.max(maxX, p.x);
                            maxY = Math.max(maxY, p.y);
                        });
                        return;
                    }
                    if(el.x1 != null) {
                        maxX = Math.max(maxX, Number(el.x1), Number(el.x2));
                        maxY = Math.max(maxY, Number(el.y1), Number(el.y2));
                        return;
                    }
                    if(el.x == null) return;
                    maxX = Math.max(maxX, Number(el.x) + Number(el.w || 0));
                    maxY = Math.max(maxY, Number(el.y) + Number(el.h || 0));
                });
                return { maxX, maxY };
            },
            FloorSetSize(preset) {
                if(!preset || (preset.w === this.viewWidth && preset.h === this.viewHeight)) return;
                const box = this.FloorContentMax();
                if(box.maxX > preset.w || box.maxY > preset.h) {
                    this.Info('Hay mesas o paredes fuera de ese tamaño');
                    return;
                }
                this.$emit('size-change', { w: preset.w, h: preset.h });
            },
            FloorNudgeSize(dir) {
                const k = Math.round(this.viewWidth / 8) + dir * FLOOR_SIZE_K.step;
                if(k < FLOOR_SIZE_K.min || k > FLOOR_SIZE_K.max) return;
                this.FloorSetSize({ w: k * 8, h: k * 5 });
            },

            // --- Estado ---
            LiveElements() {
                const list = this.mode === 'edit' ? this.elementsDraft : (this.elements || []);
                return list.filter(svgElementOnGrid);
            },
            FloorSyncFromProps() {
                this.layoutDraft = {};
                let dropped = false;
                this.tables.forEach(t => {
                    if(!t.layout || t.layout.x == null) return;
                    if(!svgBoxOnGrid(t.layout)) {
                        this.$set(this.layoutDraft, t.id, { id: t.id, x: null });
                        dropped = true;
                        return;
                    }
                    const dims = svgNormalizeDims(t.layout.shape || 'round', t.layout.w, t.layout.h);
                    this.$set(this.layoutDraft, t.id, {
                        id: t.id,
                        x: Number(t.layout.x),
                        y: Number(t.layout.y),
                        w: dims.w,
                        h: dims.h,
                        shape: t.layout.shape || 'round',
                        rotation: Number(t.layout.rotation || 0),
                    });
                });
                if(this.mode === 'edit' && dropped) this.FloorEmitChange();
            },
            FloorSyncElementsFromProps() {
                const src = this.elements || [];
                this.elementsDraft = src.filter(svgElementOnGrid).map(e => {
                    const n = Object.assign({}, e);
                    if(STAMP_TYPES.indexOf(n.type) !== -1) n.rotation = Number(n.rotation) || 0;
                    if(n.type === 'door') n.flip = !!n.flip;
                    if(n.type === 'wall') {
                        n.points = svgWallPoints(n);
                        n.closed = !!n.closed;
                    }
                    return n;
                });
                if(this.mode === 'edit' && this.elementsDraft.length !== src.length) this.FloorEmitElements();
            },
            FloorEmitChange() {
                this.dirty = true;
                this.$emit('change', this.FloorGetPayload());
            },
            FloorEmitElements() {
                this.dirty = true;
                this.$emit('elements-change', this.FloorGetElementsPayload());
            },
            FloorGetPayload() {
                return Object.keys(this.layoutDraft).map(id => {
                    const d = this.layoutDraft[id];
                    return {
                        id: Number(d.id),
                        layout: d.x == null ? null : {
                            x: d.x, y: d.y, w: d.w, h: d.h,
                            shape: d.shape, rotation: d.rotation || 0,
                        },
                    };
                });
            },
            FloorGetElementsPayload() {
                return this.elementsDraft.map(e => {
                    if(e.type === 'wall') {
                        return { id: e.id, type: 'wall', points: svgWallPoints(e), closed: !!e.closed };
                    }
                    return Object.assign({}, e);
                });
            },
            FloorMarkClean() {
                this.dirty = false;
            },
            // +/− de mesa/zona/sello. requirePlaced: la mesa tiene que estar en el lienzo (x != null).
            FloorResizeBtns(d, requirePlaced) {
                if(!d || (requirePlaced && d.x == null)) return { up: false, down: false };
                return svgResizeBtns(d);
            },

            // --- Mesas ---
            FloorGetLayout(table) {
                if(this.layoutDraft[table.id]) return this.layoutDraft[table.id];
                if(!table.layout || table.layout.x == null || !svgBoxOnGrid(table.layout)) return null;
                return {
                    id: table.id,
                    x: table.layout.x,
                    y: table.layout.y,
                    w: table.layout.w || SVG_SHAPE_SIZE.round.w,
                    h: table.layout.h || SVG_SHAPE_SIZE.round.h,
                    shape: table.layout.shape || 'round',
                    rotation: table.layout.rotation || 0,
                };
            },
            FloorResolveStatus(table) {
                if(!table.available) return 'UNAVAILABLE';
                if(table.parent_table) return 'JOINED';
                if(table.status) return table.status;
                if(table.id_transaction) return 'OPEN';
                if(table.reserved || table.reservation_data) return 'RESERVED';
                return 'AVAILABLE';
            },
            FloorBuildTableTooltip(table) {
                const lines = [table.name];
                if(table.seats && (table.status || this.FloorResolveStatus(table)) === 'AVAILABLE') lines.push(table.seats + ' sillas');
                if(table.waiter && table.waiter.name) lines.push(table.waiter.name);
                if(table.items && table.items.ready) lines.push('Listos: ' + table.items.ready);
                if(table.items && table.items.pending) lines.push('Pendientes: ' + table.items.pending);
                if(table.reservation) lines.push('Reserva: ' + table.reservation);
                if(table.parent_table) lines.push('Unida a ' + table.parent_table);
                if(table.children && table.children.length) {
                    lines.push(table.children.length === 1
                        ? 'Une a ' + table.children[0].name
                        : table.children.length + ' mesas unidas');
                }
                if(table.last_pre_print) {
                    const p = table.last_pre_print;
                    lines.push('Pre cuenta: ' + (p.date || p.time) + (p.account ? ' por ' + p.account : ''));
                }
                return lines.join('<br>');
            },
            FloorAddTable(table, x, y) {
                const count = this.placedNodes.length;
                const prev = this.lastTableSize;
                const shape = (prev && prev.shape) || 'round';
                const size = prev
                    ? { w: prev.w, h: prev.h }
                    : (SVG_SHAPE_SIZE[shape] || SVG_SHAPE_SIZE.round);
                const d = {
                    id: table.id,
                    x: svgSnapGrid(x != null ? x : 10 + (count % 8) * 10),
                    y: svgSnapGrid(y != null ? y : 10 + Math.floor(count / 8) * 12),
                    w: size.w,
                    h: size.h,
                    shape,
                    rotation: 0,
                };
                svgClampInView(d, this.viewWidth, this.viewHeight);
                this.$set(this.layoutDraft, table.id, d);
                this.selectedTableId = table.id;
                this.selectedElementId = null;
                this.FloorToast(table.name);
                this.FloorEmitChange();
            },
            FloorRememberTableSize(d) {
                if(!d || d.x == null) return;
                this.lastTableSize = { w: d.w, h: d.h, shape: d.shape || 'round' };
            },
            FloorSetShape(shape) {
                const d = this.layoutDraft[this.selectedTableId];
                if(!d) return;
                const cx = d.x + d.w / 2;
                const cy = d.y + d.h / 2;
                const size = SVG_SHAPE_SIZE[shape] || SVG_SHAPE_SIZE.round;
                d.shape = shape;
                d.w = size.w;
                d.h = size.h;
                svgPlaceAtCenter(d, cx, cy, this.viewWidth, this.viewHeight);
                this.FloorRememberTableSize(d);
                this.FloorEmitChange();
            },
            FloorResizeSelected(delta) {
                const d = this.layoutDraft[this.selectedTableId];
                if(!d || !svgCanResize(d, delta)) return;
                if((d.shape || 'round') === 'rect') {
                    const ratio = d.w / d.h || SVG_RECT_ASPECT;
                    let nh = svgClamp(svgSnapGrid(d.h + delta * SVG_SIZE.step), SVG_RECT_MIN.h, SVG_SIZE.max);
                    let nw = svgClamp(svgSnapGrid(nh * ratio), SVG_RECT_MIN.w, SVG_SIZE.max);
                    if(nw >= SVG_SIZE.max) { nw = SVG_SIZE.max; nh = svgClamp(svgSnapGrid(nw / ratio), SVG_RECT_MIN.h, SVG_SIZE.max); }
                    else if(nw <= SVG_RECT_MIN.w) { nw = SVG_RECT_MIN.w; nh = svgClamp(svgSnapGrid(nw / ratio), SVG_RECT_MIN.h, SVG_SIZE.max); }
                    d.w = nw;
                    d.h = nh;
                } else {
                    const s = svgClamp(svgSnapGrid(Math.max(d.w, d.h) + delta * SVG_SIZE.step), SVG_SIZE.min, SVG_SIZE.max);
                    d.w = s; d.h = s;
                }
                svgClampInView(d, this.viewWidth, this.viewHeight);
                this.FloorRememberTableSize(d);
                this.FloorEmitChange();
            },
            FloorRemoveFromMap() {
                if(!this.selectedTableId) return;
                this.$set(this.layoutDraft, this.selectedTableId, { id: this.selectedTableId, x: null });
                this.selectedTableId = null;
                this.FloorEmitChange();
            },

            // --- Elementos fuera de mesas---
            floorFitFont(text, w, h, maxFont) {
                return floorFitFont(text, w, h, maxFont);
            },
            stairsStepLines(w, h, rot) {
                return stairsStepLines(w, h, rot);
            },
            stairsArrowPath(w, h, rot) {
                return stairsArrowPath(w, h, rot);
            },
            svgDiamondPath(w, h, inset) {
                return svgDiamondPath(w, h, inset);
            },
            FloorSetLabelShape(shape) {
                const d = this.selectedEl;
                if(!d) return;
                const cx = d.x + d.w / 2;
                const cy = d.y + d.h / 2;
                this.$set(d, 'shape', shape);
                if(shape === 'rect' || shape === 'text') {
                    if(Math.abs(d.w - d.h) < 0.01) {
                        d.w = SVG_LABEL_SIZE.w;
                        d.h = SVG_LABEL_SIZE.h;
                    }
                } else {
                    const s = Math.max(d.w, d.h);
                    d.w = s; d.h = s;
                }
                svgPlaceAtCenter(d, cx, cy, this.viewWidth, this.viewHeight);
                this.FloorEmitElements();
            },
            FloorLabelFont(d) {
                const n = Number(d && d.fontSize);
                return n > 0 ? n : SVG_LABEL_FONT.def;
            },
            FloorResizeLabel(delta) {
                const d = this.selectedEl;
                if(!d || !svgCanResize(d, delta)) return;
                const prevH = d.h;
                if(d.shape === 'rect' || d.shape === 'text') {
                    const max = d.shape === 'text' ? SVG_LABEL_TEXT_MAX : SVG_SIZE.max;
                    const ratio = d.w / d.h || (SVG_LABEL_SIZE.w / SVG_LABEL_SIZE.h);
                    let nh = svgClamp(svgSnapGrid(d.h + delta * SVG_SIZE.step), SVG_SIZE.min, max);
                    let nw = svgClamp(svgSnapGrid(nh * ratio), SVG_SIZE.min, max);
                    d.w = svgSnapGrid(nw);
                    d.h = svgSnapGrid(nh);
                } else {
                    const s = svgClamp(svgSnapGrid(Math.max(d.w, d.h) + delta * SVG_SIZE.step), SVG_SIZE.min, SVG_SIZE.max);
                    d.w = s; d.h = s;
                }
                svgClampInView(d, this.viewWidth, this.viewHeight);
                if(prevH > 0) {
                    const fontMax = d.shape === 'text'
                        ? SVG_LABEL_FONT.def * (SVG_LABEL_TEXT_MAX / SVG_LABEL_SIZE.h)
                        : SVG_LABEL_FONT.max;
                    const next = svgClamp(this.FloorLabelFont(d) * (d.h / prevH), SVG_LABEL_FONT.min, fontMax);
                    this.$set(d, 'fontSize', Math.round(next * 10) / 10);
                }
                this.FloorEmitElements();
            },
            FloorResizeStamp(delta) {
                const d = this.selectedEl;
                if(!d || !svgCanResize(d, delta)) return;
                const range = d.type === 'stairs' ? SVG_STAIRS : SVG_SIZE;
                const s = svgClamp(svgSnapGrid(Math.max(d.w, d.h) + delta * range.step), range.min, range.max);
                d.w = s;
                d.h = s;
                svgClampInView(d, this.viewWidth, this.viewHeight);
                this.FloorEmitElements();
            },
            FloorRotateStamp(delta) {
                const d = this.selectedEl;
                if(!d || (d.type !== 'stairs' && d.type !== 'toilet')) return;
                this.$set(d, 'rotation', ((Number(d.rotation) || 0) + delta + 360) % 360);
                this.FloorEmitElements();
            },
            FloorRotateDoor(deg) {
                const d = this.selectedEl;
                if(!d || d.type !== 'door') return;
                const dx = d.x2 - d.x1;
                const dy = d.y2 - d.y1;
                const len = Math.hypot(dx, dy);
                if(len < 0.01) return;
                let q = Math.round(Math.atan2(dy, dx) / (Math.PI / 4));
                q = ((q % 8) + 8) % 8;
                q = (q + (deg > 0 ? 1 : -1) + 8) % 8;
                const dir = DOOR_DIRS[q];
                const step = (q % 2) ? SVG_GRID * Math.SQRT2 : SVG_GRID;
                const cells = Math.max(1, Math.round(len / step));
                d.x2 = svgSnapGrid(svgClamp(d.x1 + dir[0] * cells * SVG_GRID, 0, this.viewWidth));
                d.y2 = svgSnapGrid(svgClamp(d.y1 + dir[1] * cells * SVG_GRID, 0, this.viewHeight));
                this.FloorEmitElements();
            },
            FloorRemoveElement() {
                if(!this.selectedElementId) return;
                this.elementsDraft = this.elementsDraft.filter(e => e.id !== this.selectedElementId);
                this.selectedElementId = null;
                this.FloorEmitElements();
            },

            // --- Dibujo ---
            FloorPlaceStamp(type, x, y) {
                const size = type === 'stairs' ? SVG_STAIRS_SIZE : SVG_COLUMN_SIZE;
                const el = {
                    id: newElementId(type === 'stairs' ? 'st' : type === 'plant' ? 'pl' : type === 'toilet' ? 'wc' : 'col'),
                    type,
                    x: svgClamp(svgSnapCell(x), 0, this.viewWidth - size.w),
                    y: svgClamp(svgSnapCell(y), 0, this.viewHeight - size.h),
                    w: size.w,
                    h: size.h,
                    rotation: 0,
                };
                this.elementsDraft.push(el);
                svgClampInView(el, this.viewWidth, this.viewHeight);
                this.selectedTableId = null;
                this.selectedElementId = el.id;
                this.FloorEmitElements();
            },
            FloorAddWallVertex(x, y) {
                if(!this.pathDraft) {
                    this.pathDraft = { id: null, x, y, firstX: x, firstY: y };
                    this.lineDraft = { type: 'wall', x1: x, y1: y, x2: x, y2: y };
                    return;
                }
                const last = this.pathDraft;
                if(Math.abs(x - last.x) < 1 && Math.abs(y - last.y) < 1) {
                    this.FloorFinishWallPath();
                    return;
                }
                const nearFirst = Math.abs(x - last.firstX) < 2 && Math.abs(y - last.firstY) < 2;
                if(last.id) {
                    const el = this.elementsDraft.find(e => e.id === last.id);
                    if(!el) {
                        this.FloorFinishWallPath();
                        return;
                    }
                    if(nearFirst && el.points.length >= 2) {
                        this.$set(el, 'closed', true);
                        this.FloorEmitElements();
                        this.FloorFinishWallPath();
                        return;
                    }
                    el.points.push({ x, y });
                } else {
                    const el = {
                        id: newElementId('w'),
                        type: 'wall',
                        points: [{ x: last.firstX, y: last.firstY }, { x, y }],
                        closed: false,
                    };
                    this.elementsDraft.push(el);
                    last.id = el.id;
                    this.selectedTableId = null;
                    this.selectedElementId = el.id;
                }
                last.x = x;
                last.y = y;
                this.lineDraft = { type: 'wall', x1: x, y1: y, x2: x, y2: y };
                this.FloorEmitElements();
            },
            FloorUseRefTool() {
                if(this.tool !== 'ref') this.FloorSetTool('ref');
                if(!this.refImage) this.FloorPickRefImage();
            },
            FloorPickRefImage() {
                if(this.$refs.refImageInput) this.$refs.refImageInput.click();
            },
            FloorEmitRef() {
                if(!this.refImage) {
                    this.$emit('ref-change', null);
                    return;
                }
                this.$emit('ref-change', {
                    url: this.refImage,
                    x: this.ref.x,
                    y: this.ref.y,
                    scale: this.ref.scale,
                });
            },
            FloorOnRefImage(e) {
                const file = e.target.files && e.target.files[0];
                e.target.value = '';
                if(!file) return;
                this.refImage = URL.createObjectURL(file);
                this.ref = { x: 0, y: 0, scale: 1 };
                this.refMove = true;
                this.FloorEmitRef();
            },
            FloorClearRef() {
                this.refImage = null;
                this.refMove = false;
                this.ref = { x: 0, y: 0, scale: 1 };
                this.FloorEmitRef();
            },
            FloorResetRef() {
                this.ref = { x: 0, y: 0, scale: 1 };
                if(this.refImage) this.FloorEmitRef();
            },
            FloorZoomRef(dir, pivot) {
                if(!this.refImage) return;
                const next = svgClamp(this.ref.scale * (dir > 0 ? 1.15 : 1 / 1.15), 0.4, 5);
                const k = next / this.ref.scale;
                const cx = pivot ? pivot.x : this.viewWidth / 2;
                const cy = pivot ? pivot.y : this.viewHeight / 2;
                this.ref.x = cx - (cx - this.ref.x) * k;
                this.ref.y = cy - (cy - this.ref.y) * k;
                this.ref.scale = next;
                this.FloorEmitRef();
            },
            FloorOnRefWheel(e) {
                if(!this.refImage || this.tool !== 'ref') return;
                e.preventDefault();
                this.FloorZoomRef(e.deltaY < 0 ? 1 : -1, this.SvgClientToLocal(e.clientX, e.clientY));
            },
            FloorOnRefPointerDown(e) {
                if(e.button != null && e.button !== 0) return;
                const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                this.drag = { kind: 'ref', offsetX: pos.x - this.ref.x, offsetY: pos.y - this.ref.y };
            },
            FloorSetTool(tool) {
                this.refMove = tool === 'ref' && !!this.refImage;
                if(this.tool === tool) return;
                this.FloorClearSelection();
                this.tool = tool;
                this.FloorToast(FLOOR_TOOL_LABELS[tool] || tool);
            },
            FloorToast(text) {
                if(!text) return;
                this.Toast({text, override: true});
            },
            FloorFinishWallPath() {
                this.pathDraft = null;
                if(this.lineDraft && this.lineDraft.type === 'wall') this.lineDraft = null;
            },
            FloorOnKeyDown(e) {
                if(this.mode !== 'edit' || e.key !== 'Delete') return;
                const t = e.target;
                if(t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
                if(!this.selectedTableIds.length && !this.selectedElementIds.length) return;
                e.preventDefault();
                this.FloorRemoveSelection();
            },

            // --- Selección múltiple ---
            // Destilda mesas y elementos.
            FloorClearSelection() {
                this.selectedTableIds = [];
                this.selectedElementIds = [];
            },
            // Highlight en el SVG (mesa o elemento está en el set).
            FloorTableIsSelected(id) { return this.selectedTableIds.indexOf(id) !== -1; },
            FloorElementIsSelected(id) { return this.selectedElementIds.indexOf(id) !== -1; },
            // Si el ítem no estaba en el set, la selección pasa a ser solo ese.
            FloorPickOnly(kind, id) {
                if(kind === 'table' && this.selectedTableIds.indexOf(id) !== -1) return;
                if(kind === 'element' && this.selectedElementIds.indexOf(id) !== -1) return;
                this.selectedTableIds = kind === 'table' ? [id] : [];
                this.selectedElementIds = kind === 'element' ? [id] : [];
                if(kind === 'table') {
                    const t = this.tables.find(x => x.id === id);
                    if(t) this.FloorToast(t.name);
                }
            },
            // Marca lo que toca el marquee. Rect chico = click en vacío = nada seleccionado.
            FloorApplyMarquee() {
                if(!this.marquee) return;
                const r = svgNormRect(this.marquee.x1, this.marquee.y1, this.marquee.x2, this.marquee.y2);
                if(r.w < MARQUEE_MIN && r.h < MARQUEE_MIN) return this.FloorClearSelection();
                this.selectedTableIds = this.placedNodes.filter(n => svgRectsHit(r, svgItemBox(n))).map(n => n.id);
                this.selectedElementIds = this.elementsDraft.filter(el => svgMarqueeHits(el, r)).map(el => el.id);
            },
            // Empieza el rectángulo de selección en el piso vacío.
            FloorStartMarquee(pos) {
                this.FloorClearSelection();
                this.marquee = { x1: pos.x, y1: pos.y, x2: pos.x, y2: pos.y };
            },
            // Guarda posiciones origen para mover todo el set con el mismo delta.
            FloorStartGroupDrag(pos) {
                const origin = (id, el) => {
                    if(!el) return null;
                    if(el.type === 'wall' || (el.points && el.points.length)) {
                        return { id, points: svgWallPoints(el) };
                    }
                    if(el.x1 != null) return { id, x1: el.x1, y1: el.y1, x2: el.x2, y2: el.y2 };
                    if(el.x == null) return null;
                    return { id, x: el.x, y: el.y };
                };
                this.drag = {
                    kind: 'group', startX: pos.x, startY: pos.y,
                    tables: this.selectedTableIds.map(id => origin(id, this.layoutDraft[id])).filter(Boolean),
                    elements: this.selectedElementIds.map(id => origin(id, this.elementsDraft.find(e => e.id === id))).filter(Boolean),
                };
            },
            // Mueve el grupo: mismo dx/dy, clamp al lienzo.
            FloorMoveGroup(pos) {
                let dx = svgSnapGrid(pos.x - this.drag.startX);
                let dy = svgSnapGrid(pos.y - this.drag.startY);
                const pts = [];
                this.drag.tables.forEach(o => {
                    const cur = this.layoutDraft[o.id];
                    if(!cur) return;
                    pts.push({ x: o.x, y: o.y }, { x: o.x + cur.w, y: o.y + cur.h });
                });
                this.drag.elements.forEach(o => {
                    if(o.points) o.points.forEach(p => pts.push(p));
                    else if(o.x1 != null) pts.push({ x: o.x1, y: o.y1 }, { x: o.x2, y: o.y2 });
                    else {
                        const cur = this.elementsDraft.find(e => e.id === o.id);
                        if(!cur) return;
                        pts.push({ x: o.x, y: o.y }, { x: o.x + cur.w, y: o.y + cur.h });
                    }
                });
                const fit = svgFitDelta(dx, dy, pts, this.viewWidth, this.viewHeight);
                dx = fit.dx;
                dy = fit.dy;
                const shift = (o, cur) => {
                    if(!cur) return;
                    if(o.points) cur.points = o.points.map(p => ({ x: p.x + dx, y: p.y + dy }));
                    else if(o.x1 != null) {
                        cur.x1 = o.x1 + dx; cur.y1 = o.y1 + dy;
                        cur.x2 = o.x2 + dx; cur.y2 = o.y2 + dy;
                    } else {
                        cur.x = o.x + dx;
                        cur.y = o.y + dy;
                    }
                };
                this.drag.tables.forEach(o => shift(o, this.layoutDraft[o.id]));
                this.drag.elements.forEach(o => shift(o, this.elementsDraft.find(e => e.id === o.id)));
                if(this.drag.tables.length) this.FloorEmitChange();
                if(this.drag.elements.length) this.FloorEmitElements();
            },
            // Quita del mapa todas las mesas y elementos del set.
            FloorRemoveSelection() {
                const tableIds = this.selectedTableIds.slice();
                const elIds = this.selectedElementIds.slice();
                tableIds.forEach(id => {
                    this.$set(this.layoutDraft, id, { id, x: null });
                });
                if(elIds.length) this.elementsDraft = this.elementsDraft.filter(e => elIds.indexOf(e.id) === -1);
                this.FloorClearSelection();
                if(tableIds.length) this.FloorEmitChange();
                if(elIds.length) this.FloorEmitElements();
            },

            // --- Pointer ---
            FloorApplyToolAt(x, y) {
                const gx = svgSnapGrid(svgClamp(x, 0, this.viewWidth));
                const gy = svgSnapGrid(svgClamp(y, 0, this.viewHeight));
                if(this.tool === 'wall') {
                    this.FloorClearSelection();
                    this.FloorAddWallVertex(gx, gy);
                    return true;
                }
                if(this.tool === 'door' || this.tool === 'window') {
                    this.FloorClearSelection();
                    this.lineDraft = { type: this.tool, x1: gx, y1: gy, x2: gx, y2: gy };
                    return true;
                }
                if(STAMP_TYPES.indexOf(this.tool) !== -1) {
                    this.FloorPlaceStamp(this.tool, x, y);
                    return true;
                }
                if(this.tool === 'label') {
                    const size = SVG_LABEL_SIZE;
                    const el = {
                        id: newElementId('l'),
                        type: 'label',
                        x: svgClamp(svgSnapCell(x), 0, this.viewWidth - size.w),
                        y: svgClamp(svgSnapCell(y), 0, this.viewHeight - size.h),
                        w: size.w,
                        h: size.h,
                        shape: 'text',
                        text: this.pendingLabelText || 'Texto',
                    };
                    this.elementsDraft.push(el);
                    svgClampInView(el, this.viewWidth, this.viewHeight);
                    this.selectedTableId = null;
                    this.selectedElementId = el.id;
                    this.FloorEmitElements();
                    return true;
                }
                return false;
            },
            FloorOnStagePointerDown(e) {
                if(this.mode !== 'edit') return;
                if(e.button === 2) {
                    this.FloorFinishWallPath();
                    return;
                }
                const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                if(this.FloorApplyToolAt(pos.x, pos.y)) return;
                if(e.button != null && e.button !== 0) return;
                this.FloorStartMarquee(pos);
            },
            // Click en mesa: si no estaba en el set, queda sola. Si el set tiene más de una, arrastra el grupo.
            FloorOnTablePointerDown(e, node) {
                if(this.mode !== 'edit') return;
                if(e.button === 2) {
                    this.FloorFinishWallPath();
                    return;
                }
                if(this.tool !== 'select') {
                    const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                    this.FloorApplyToolAt(pos.x, pos.y);
                    return;
                }
                if(e.button != null && e.button !== 0) return;
                this.FloorPickOnly('table', node.id);
                const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                if(this.isMultiSelect) this.FloorStartGroupDrag(pos);
                else this.drag = { kind: 'table', id: node.id, offsetX: pos.x - node.x, offsetY: pos.y - node.y };
                if(e.currentTarget && e.currentTarget.setPointerCapture) {
                    try { e.currentTarget.setPointerCapture(e.pointerId); } catch(err) {}
                }
            },
            FloorOnElementClick() {},
            // Igual que mesas, para paredes/zonas/sellos.
            FloorOnElementPointerDown(e, el) {
                if(this.mode !== 'edit') return;
                if(e.button === 2) {
                    this.FloorFinishWallPath();
                    return;
                }
                if(this.tool !== 'select') {
                    const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                    this.FloorApplyToolAt(pos.x, pos.y);
                    return;
                }
                if(e.button != null && e.button !== 0) return;
                this.FloorPickOnly('element', el.id);
                const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                if(this.isMultiSelect) this.FloorStartGroupDrag(pos);
                else if(el.type === 'label' || STAMP_TYPES.indexOf(el.type) !== -1) {
                    this.drag = { kind: 'box', id: el.id, offsetX: pos.x - el.x, offsetY: pos.y - el.y };
                } else if(el.type === 'wall') {
                    this.drag = { kind: 'wall', id: el.id, startX: pos.x, startY: pos.y, points: svgWallPoints(el) };
                } else {
                    this.drag = { kind: 'segment', id: el.id, startX: pos.x, startY: pos.y, x1: el.x1, y1: el.y1, x2: el.x2, y2: el.y2 };
                }
                if(e.currentTarget && e.currentTarget.setPointerCapture) {
                    try { e.currentTarget.setPointerCapture(e.pointerId); } catch(err) {}
                }
            },
            // Marquee y drag de grupo; el resto es ítem suelto o dibujo de línea.
            FloorOnPointerMove(e) {
                const pos = this.SvgClientToLocal(e.clientX, e.clientY);
                if(this.marquee) {
                    this.marquee.x2 = pos.x;
                    this.marquee.y2 = pos.y;
                    this.FloorApplyMarquee();
                    return;
                }
                if(this.lineDraft) {
                    this.lineDraft.x2 = svgSnapGrid(svgClamp(pos.x, 0, this.viewWidth));
                    this.lineDraft.y2 = svgSnapGrid(svgClamp(pos.y, 0, this.viewHeight));
                    return;
                }
                if(!this.drag) return;
                if(this.drag.kind === 'ref') {
                    this.ref.x = pos.x - this.drag.offsetX;
                    this.ref.y = pos.y - this.drag.offsetY;
                    return;
                }
                if(this.drag.kind === 'group') {
                    this.FloorMoveGroup(pos);
                    return;
                }
                if(this.drag.kind === 'table') {
                    const d = this.layoutDraft[this.drag.id];
                    if(!d) return;
                    d.x = svgClamp(svgSnapGrid(pos.x - this.drag.offsetX), 0, this.viewWidth - d.w);
                    d.y = svgClamp(svgSnapGrid(pos.y - this.drag.offsetY), 0, this.viewHeight - d.h);
                    this.FloorEmitChange();
                    return;
                }
                const el = this.elementsDraft.find(x => x.id === this.drag.id);
                if(!el) return;
                if(this.drag.kind === 'box' || this.drag.kind === 'label') {
                    el.x = svgClamp(svgSnapGrid(pos.x - this.drag.offsetX), 0, this.viewWidth - el.w);
                    el.y = svgClamp(svgSnapGrid(pos.y - this.drag.offsetY), 0, this.viewHeight - el.h);
                    this.FloorEmitElements();
                    return;
                }
                if(this.drag.kind === 'wall') {
                    const fit = svgFitDelta(
                        svgSnapGrid(pos.x - this.drag.startX),
                        svgSnapGrid(pos.y - this.drag.startY),
                        this.drag.points,
                        this.viewWidth,
                        this.viewHeight
                    );
                    el.points = this.drag.points.map(p => ({ x: p.x + fit.dx, y: p.y + fit.dy }));
                    this.FloorEmitElements();
                    return;
                }
                if(this.drag.kind === 'segment') {
                    const fit = svgFitDelta(
                        svgSnapGrid(pos.x - this.drag.startX),
                        svgSnapGrid(pos.y - this.drag.startY),
                        [{ x: this.drag.x1, y: this.drag.y1 }, { x: this.drag.x2, y: this.drag.y2 }],
                        this.viewWidth,
                        this.viewHeight
                    );
                    el.x1 = this.drag.x1 + fit.dx;
                    el.y1 = this.drag.y1 + fit.dy;
                    el.x2 = this.drag.x2 + fit.dx;
                    el.y2 = this.drag.y2 + fit.dy;
                    this.FloorEmitElements();
                }
            },
            FloorOnPointerUp() {
                if(this.marquee) {
                    this.FloorApplyMarquee();
                    this.marquee = null;
                    return;
                }
                if(this.pathDraft) return;
                if(this.lineDraft) {
                    const d = this.lineDraft;
                    this.lineDraft = null;
                    if(Math.abs(d.x2 - d.x1) < 1 && Math.abs(d.y2 - d.y1) < 1) return;
                    const el = {
                        id: newElementId(SEGMENT_PREFIX[d.type] || 's'),
                        type: d.type,
                        x1: d.x1, y1: d.y1, x2: d.x2, y2: d.y2,
                    };
                    if(d.type === 'door') el.flip = false;
                    this.elementsDraft.push(el);
                    this.selectedElementId = el.id;
                    this.FloorEmitElements();
                    return;
                }
                const wasRef = this.drag && this.drag.kind === 'ref';
                this.drag = null;
                if(wasRef) this.FloorEmitRef();
            },

            // --- Operar ---
            FloorOnTableClick(node) {
                if(this.mode === 'operate') {
                    this.$emit('select', node.table);
                }
            },
        },
    };
    </script>

    <style>
    /* Tokens, barras flotantes y paint del SVG. scoped para no pisar .tooltip del admin. */
    .floor-map {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        width: 100%;
        align-items: stretch;
        --floor-stage-bg: var(--gray-bg);
        --floor-canvas-bg: #fff;
        --floor-grid: rgba(0, 0, 0, 0.06);
        --floor-ink: #555;
        --floor-ink-strong: #333;
        --floor-table-fill: #fff;
        --floor-table-stroke: #8b8da8;
        --floor-table-label: #222;
        --floor-chair: #6e7088;
        --floor-table-shadow: rgba(35, 35, 35, 0.18);
        --floor-unavailable-fill: #f5f5f5;
        --floor-unavailable-stroke: #ccc;
        --floor-column-fill: #e8e8e8;
        --floor-accent: #4285f4;
        --floor-accent-fill: rgba(66, 133, 244, 0.12);
        --floor-label-fill: rgba(85, 85, 85, 0.04);
        --floor-bar-bg: var(--gray-3);
        --floor-bar-border: var(--gray-2);
        --floor-bar-text: var(--gray-1);
        --floor-bar-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        --floor-window-fill: #fff;
        --floor-tool-filter: none;
    }
    body.dark .floor-map {
        --floor-stage-bg: var(--dark-bg-0);
        --floor-canvas-bg: var(--dark-bg-1);
        --floor-grid: rgba(255, 255, 255, 0.08);
        --floor-ink: var(--dark-fc-2);
        --floor-ink-strong: var(--dark-fc-1);
        --floor-table-fill: #4a4c5c;
        --floor-table-stroke: #b4b7c9;
        --floor-table-label: var(--dark-fc-1);
        --floor-chair: #9aa0b5;
        --floor-table-shadow: rgba(0, 0, 0, 0.45);
        --floor-unavailable-fill: var(--dark-bg-0);
        --floor-unavailable-stroke: var(--dark-outline);
        --floor-column-fill: var(--dark-bg-2);
        --floor-accent: #8ab4f8;
        --floor-accent-fill: rgba(138, 180, 248, 0.18);
        --floor-label-fill: rgba(231, 236, 245, 0.06);
        --floor-bar-bg: var(--dark-bg-2);
        --floor-bar-border: var(--dark-outline);
        --floor-bar-text: var(--dark-fc-2);
        --floor-window-fill: var(--dark-bg-2);
        --floor-bar-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
        --floor-tool-filter: invert(1);
    }
    .floor-map.operate {
        --floor-canvas-bg: var(--gray-bg);
    }
    body.dark .floor-map.operate {
        --floor-stage-bg: var(--dark-bg);
        --floor-canvas-bg: var(--dark-bg);
    }
    /* altura fija: tools + props siempre ocupan el mismo espacio */
    .floor-map-chrome {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 10px;
        min-height: 92px;
    }
    .floor-map-tools,
    .floor-map-props {
        flex-wrap: wrap;
        gap: 4px;
        min-height: 40px;
        align-items: center;
    }
    .floor-map-props-placeholder {
        font-size: 13px;
        line-height: 1.2;
        opacity: 0.75;
    }
    .floor-map.operate,
    .floor-map.edit {
        width: 100%;
        max-width: 100%;
        align-items: stretch;
        flex: 1;
        min-height: 0;
        height: 100%;
    }
    .floor-map-stage {
        position: relative;
        width: 100%;
        max-width: 100%;
        aspect-ratio: 16 / 10;
        max-height: min(70vh, calc(100vw * 10 / 16));
        height: auto;
        margin: 0 auto;
        flex: 0 0 auto;
        background: var(--floor-stage-bg);
        overflow: hidden;
        touch-action: none;
    }
    .floor-map-scroll {
        position: absolute;
        inset: 0;
        min-width: 0;
        overflow: hidden;
    }
    .floor-map-sizer {
        width: 100%;
        height: 100%;
    }
    .floor-map-toolbar-toggle {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 3;
        pointer-events: auto;
    }
    .floor-map-float-label {
        max-width: 80vw;
    }
    .floor-map-float-label,
    .floor-map-float-label-rigth,
    .floor-map-unplaced-bar,
    .floor-map-size-bar {
        z-index: 2;
        pointer-events: auto;
        background: var(--floor-bar-bg);
        border: 1px solid var(--floor-bar-border);
        border-radius: 8px;
        box-shadow: var(--floor-bar-shadow);
        color: var(--floor-bar-text);
        font-size: 13px;
        font-weight: 600;
        line-height: 1.2;
        transition: opacity 0.15s ease;
    }
    .floor-map-float-label.dimmed,
    .floor-map-float-label-rigth.dimmed,
    .floor-map-unplaced-bar.dimmed,
    .floor-map-size-bar.dimmed {
        opacity: 0.35;
        pointer-events: none;
    }
    .floor-map-float-label {
        position: absolute;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 8px;
        white-space: nowrap;
    }
    .floor-map-float-label-rigth {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 8px;
        white-space: nowrap;
    }
    .floor-map-unplaced-bar {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 8px;
        max-height: calc(100% - 88px);
        overflow-y: auto;
    }
    /* Mobile */
    @media (max-width: 820px) {
        .floor-map-unplaced-bar {
            bottom: 40px;
            top: unset;
            flex-direction: row;
            max-width: calc(100% - 20px);
        }
        .floor-unplaced-title {
            display: none;
        }
        .floor-map-float-label {
            left: 10px;
            transform: unset;
            overflow-x: auto;
        }
        .floor-map-float-label-rigth {
            top: 102px;
            left: 10px;
            right: unset;
            flex-direction: row;
        }
    }
    .floor-unplaced-title {
        padding: 6px 4px;
        text-align: center;
        white-space: nowrap;
    }
    .floor-map-unplaced-bar .floor-map-tool-sep {
        width: auto;
        height: 1px;
        flex-shrink: 0;
    }
    .floor-map-unplaced-bar button {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }
    .floor-map-size-bar {
        position: absolute;
        left: 10px;
        bottom: 10px;
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 6px 10px;
        white-space: nowrap;
    }
    .floor-map.edit .floor-map-stage,
    /* operate/edit: llenar el hueco del padre; el SVG hace meet (letterbox ok) */
    .floor-map.operate .floor-map-stage {
        flex: 1;
        width: 100%;
        height: auto;
        max-height: none;
        aspect-ratio: unset;
        margin: 0;
        min-height: 0;
    }
    .floor-map-svg {
        width: 100%;
        height: 100%;
        display: block;
        user-select: none;
    }
    @media (max-width: 820px) {
        .floor-map.operate .floor-map-stage {
            touch-action: pan-x;
        }
        .floor-map.operate .floor-map-scroll {
            overflow-x: auto;
            overflow-y: hidden;
            touch-action: pan-x;
            overscroll-behavior-x: contain;
            -webkit-overflow-scrolling: touch;
        }
        .floor-map.operate .floor-map-sizer {
            width: auto;
            height: 100%;
            aspect-ratio: var(--floor-w) / var(--floor-h);
            margin-inline: auto;
        }
    }
    .floor-map.ref-move .floor-map-svg { cursor: grab; }
    .floor-ref-hit { fill: transparent; cursor: grab; }
    .floor-canvas {
        fill: var(--floor-canvas-bg);
    }
    .floor-map-float-label-rigth button.selected {
        outline: 2px solid var(--purple);
        border-color: var(--purple);
    }
    .floor-map-float-label button.primary:enabled:hover,
    .floor-map-size-bar button.primary:enabled:hover {
        transform: none;
        box-shadow: none;
    }
    .floor-map-icon-btn {
        min-width: 34px;
        min-height: 34px;
        padding: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }
    .floor-map-icon-btn .icon {
        font-size: 16px;
        margin: 0;
    }
    .floor-pm-glyph {
        font-size: 22px;
        line-height: 1;
        font-weight: 500;
    }
    .floor-label-name {
        width: 140px;
        font-weight: 400;
    }
    .floor-label-name input {
        font-size: 14px;
        font-weight: 400;
    }
    .floor-tool-glyph {
        width: 16px;
        height: 16px;
        display: block;
        pointer-events: none;
        object-fit: contain;
    }
    .floor-map-float-label svg.floor-tool-glyph {
        filter: var(--floor-tool-filter);
        color: #333;
    }
    .floor-map-float-label button.primary svg.floor-tool-glyph {
        filter: invert(1);
    }
    .floor-map-tool-sep {
        width: 1px;
        align-self: stretch;
        background: var(--floor-bar-border);
        margin: 2px 2px;
    }
    .floor-map-float-label-rigth .floor-map-tool-sep {
        width: auto;
        height: 1px;
    }
    .floor-map-props button:disabled,
    .floor-map-size-bar button:disabled,
    .floor-map-float-label-rigth button:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }
    .floor-table { cursor: pointer; filter: drop-shadow(0 0.4px 0.5px var(--floor-table-shadow)); }
    .floor-table.editable,
    .floor-label-node.editable,
    .floor-segment.editable,
    .floor-wall.editable,
    .floor-door.editable,
    .floor-window.editable,
    .floor-stamp.editable { cursor: grab; }
    .floor-map.placing .floor-map-stage,
    .floor-map.placing .floor-table,
    .floor-map.placing .floor-table.editable,
    .floor-map.placing .floor-label-node.editable,
    .floor-map.placing .floor-segment.editable,
    .floor-map.placing .floor-wall.editable,
    .floor-map.placing .floor-door.editable,
    .floor-map.placing .floor-window.editable,
    .floor-map.placing .floor-stamp.editable { cursor: crosshair; }
    .floor-grid-line { stroke: var(--floor-grid); }
    .floor-chair {
        fill: none;
        stroke: var(--floor-chair);
        stroke-width: 0.35;
        stroke-linecap: round;
        pointer-events: none;
    }
    .floor-table.selected {
        filter: drop-shadow(0 0 1.1px var(--floor-accent));
    }
    .floor-label-node.selected ellipse,
    .floor-label-node.selected rect:not(.floor-stamp-hit) {
        stroke-width: 0.85;
        stroke: var(--floor-ink-strong);
    }
    .floor-label-node.selected.text-only .floor-stamp-hit {
        stroke: var(--floor-ink-strong);
        stroke-width: 0.4;
        stroke-dasharray: 1.1 0.7;
    }
    .floor-marquee {
        fill: var(--floor-accent-fill);
        stroke: var(--floor-accent);
        stroke-width: 0.4;
        pointer-events: none;
    }
    .floor-table-body { stroke-width: 0.45; }
    .floor-table:not(.selected):hover {
        filter: drop-shadow(0 0 0.18px var(--floor-status, var(--floor-ink-strong)));
    }
    .floor-table:not(.selected):hover .floor-table-body {
        stroke-width: 0.75px;
    }
    .floor-table.AVAILABLE { --floor-status: var(--floor-table-stroke); }
    .floor-table.OPEN { --floor-status: var(--green); }
    .floor-table.PENDING { --floor-status: var(--yellow); }
    .floor-table.READY { --floor-status: var(--red); }
    .floor-table.RESERVED { --floor-status: var(--blue-2); }
    .floor-table.JOINED { --floor-status: var(--gray-2); }
    .floor-table.UNAVAILABLE { --floor-status: var(--floor-unavailable-stroke); }
    .floor-table.AVAILABLE .floor-table-body { fill: var(--floor-table-fill); stroke: var(--floor-status); }
    .floor-table.OPEN .floor-table-body { fill: var(--floor-table-fill); stroke: var(--floor-status); }
    .floor-table.PENDING .floor-table-body { fill: var(--floor-table-fill); stroke: var(--floor-status); }
    .floor-table.READY .floor-table-body { fill: var(--floor-table-fill); stroke: var(--floor-status); }
    .floor-table.RESERVED .floor-table-body { fill: var(--floor-table-fill); stroke: var(--floor-status); stroke-dasharray: 1.2 0.8; }
    .floor-table.JOINED .floor-table-body {
        fill: var(--floor-table-fill);
        stroke: var(--gray-2);
        stroke-width: 0.22;
    }
    .floor-table.JOINED .floor-chair,
    .floor-table.JOINED .floor-table-label,
    .floor-table.JOINED .floor-table-status { opacity: 0.5; }
    .floor-table.JOINED:not(.selected):hover .floor-table-body { stroke-width: 0.28; }
    .floor-table-inner {
        fill: none;
        stroke-width: 0.45;
        pointer-events: none;
    }
    .floor-table.AVAILABLE .floor-table-inner { stroke: var(--floor-table-stroke); }
    .floor-table.OPEN .floor-table-inner { stroke: var(--green); }
    .floor-table.PENDING .floor-table-inner { stroke: var(--yellow); }
    .floor-table.READY .floor-table-inner { stroke: var(--red); }
    .floor-table.RESERVED .floor-table-inner { stroke: var(--blue-2); stroke-dasharray: 1.2 0.8; }
    .floor-table.JOINED .floor-table-inner { stroke: var(--gray-2); }
    .floor-table.parent:not(.selected):hover .floor-table-inner { stroke-width: 0.75px; }
    .floor-table.JOINED:not(.selected):hover .floor-table-inner { stroke-width: 0.28; }
    .floor-join-link {
        fill: none;
        stroke: var(--floor-ink);
        stroke-width: 0.35;
        stroke-dasharray: 1.2 0.8;
        stroke-linecap: round;
        pointer-events: none;
    }
    .floor-table.UNAVAILABLE { opacity: 0.4; }
    .floor-table.UNAVAILABLE .floor-table-body { fill: var(--floor-unavailable-fill); stroke: var(--floor-unavailable-stroke); }
    .floor-table.selected .floor-table-body,
    .floor-table.selected .floor-table-inner {
        stroke: var(--floor-accent);
        stroke-dasharray: none;
    }
    .floor-table.selected .floor-table-body {
        stroke-width: 1.2;
    }
    .floor-table-label {
        font-weight: 700;
        fill: var(--floor-table-label);
        pointer-events: none;
    }
    .floor-table-status { pointer-events: none; }
    .floor-table-status-pad {
        fill: var(--floor-table-fill);
        stroke: var(--floor-table-stroke);
        stroke-width: 0.35;
    }
    .floor-table.OPEN .floor-table-status-pad { fill: var(--green); stroke: var(--green); }
    .floor-table.PENDING .floor-table-status-pad { fill: var(--yellow); stroke: var(--yellow); }
    .floor-table.READY .floor-table-status-pad { fill: var(--red); stroke: var(--red); }
    .floor-table.RESERVED .floor-table-status-pad { fill: var(--blue-2); stroke: var(--blue-2); }
    .floor-table.JOINED .floor-table-status-pad { fill: var(--gray-2); stroke: var(--gray-2); }
    .floor-table-status-icon {
        font-family: "influye-font";
        font-size: 2.4px;
        fill: #000;
        alignment-baseline: central;
    }
    .floor-table-status-count {
        font-size: 2.2px;
        font-weight: 700;
        fill: #000;
        pointer-events: none;
    }
    .floor-table-preprint { pointer-events: none; }
    .floor-table-preprint-pad {
        fill: var(--floor-status);
        stroke: var(--floor-status);
        stroke-width: 0.22;
    }
    .floor-table-preprint-icon {
        font-family: "influye-font";
        font-size: 1.45px;
        fill: #000;
    }
    .floor-table-preprint-time {
        font-size: 1.3px;
        font-weight: 600;
        fill: #000;
        pointer-events: none;
    }
    .floor-segment {
        stroke: var(--floor-ink);
        stroke-width: 1.2;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: none;
        pointer-events: stroke;
    }
    .floor-segment.draft {
        stroke: var(--floor-accent);
        opacity: 0.7;
    }
    .floor-wall-vertex {
        fill: var(--floor-accent);
        pointer-events: none;
    }
    .floor-segment.wall {
        fill: none;
    }
    .floor-segment.selected {
        stroke: var(--floor-ink-strong);
        stroke-width: 1.8;
    }
    .floor-wall-hit {
        fill: none;
        stroke: transparent;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-linejoin: round;
        pointer-events: stroke;
    }
    .floor-wall.selected .floor-segment {
        stroke: var(--floor-ink-strong);
        stroke-width: 1.8;
    }
    .floor-door-hit {
        stroke: transparent;
        stroke-width: 4;
        fill: none;
        pointer-events: stroke;
    }
    .floor-door-frame {
        fill: none;
        stroke: var(--floor-ink);
        stroke-width: 1.35;
        stroke-linecap: square;
        stroke-linejoin: miter;
        pointer-events: stroke;
    }
    .floor-door-arc {
        fill: none;
        stroke: var(--floor-ink);
        stroke-width: 0.45;
        stroke-linecap: butt;
        stroke-dasharray: 2.2 0.8;
        pointer-events: none;
    }
    .floor-door.draft {
        opacity: 0.7;
    }
    .floor-door.draft .floor-door-frame { stroke: var(--floor-accent); }
    .floor-door.draft .floor-door-arc { stroke: var(--floor-accent); }
    .floor-door.selected .floor-door-frame {
        stroke: var(--floor-ink-strong);
        stroke-width: 1.7;
    }
    .floor-door.selected .floor-door-arc {
        stroke: var(--floor-ink-strong);
        stroke-width: 0.6;
    }
    .floor-window-fill {
        fill: var(--floor-window-fill);
        stroke: none;
        pointer-events: none;
    }
    .floor-window-hit {
        stroke: transparent;
        stroke-width: 4;
        fill: none;
        pointer-events: stroke;
    }
    .floor-window-line {
        stroke: var(--floor-ink);
        stroke-width: 0.7;
        stroke-linecap: butt;
        fill: none;
        pointer-events: none;
    }
    .floor-window.draft { opacity: 0.7; }
    .floor-window.draft .floor-window-line { stroke: var(--floor-accent); }
    .floor-window.selected .floor-window-line {
        stroke: var(--floor-ink-strong);
        stroke-width: 0.95;
    }
    .floor-stamp.column,
    .floor-stamp.plant,
    .floor-stamp.toilet {
        opacity: 0.6;
    }
    .floor-stamp.column.selected,
    .floor-stamp.plant.selected,
    .floor-stamp.toilet.selected {
        opacity: 1;
    }
    .floor-stamp-hit {
        fill: transparent;
        stroke: none;
        pointer-events: all;
    }
    .floor-stairs-outline {
        fill: var(--floor-label-fill);
        stroke: var(--floor-ink);
        stroke-width: 0.45;
        pointer-events: none;
    }
    .floor-stairs-step {
        stroke: var(--floor-ink);
        stroke-width: 0.35;
        pointer-events: none;
    }
    .floor-stairs-arrow {
        fill: none;
        stroke: var(--floor-ink);
        stroke-width: 0.45;
        stroke-linecap: round;
        stroke-linejoin: round;
        pointer-events: none;
    }
    .floor-stamp.selected .floor-stairs-outline,
    .floor-stamp.selected .floor-stairs-step,
    .floor-stamp.selected .floor-stairs-arrow {
        stroke: var(--floor-ink-strong);
    }
    .floor-column-outer {
        fill: var(--floor-column-fill);
        stroke: var(--floor-ink);
        stroke-width: 0.45;
        pointer-events: none;
    }
    .floor-column-core {
        fill: var(--floor-ink);
        stroke: none;
        pointer-events: none;
    }
    .floor-stamp.selected .floor-column-outer {
        stroke: var(--floor-ink-strong);
        stroke-width: 0.65;
    }
    .floor-stamp-ink {
        fill: var(--floor-ink);
        stroke: 15;
        stroke-linejoin: round;
        pointer-events: none;
    }
    .floor-stamp.plant .floor-stamp-ink { stroke-width: 8; }
    .floor-stamp.toilet .floor-stamp-ink { stroke-width: 20; }
    .floor-stamp.selected .floor-stamp-ink {
        fill: var(--floor-ink-strong);
        stroke: var(--floor-ink-strong);
    }
    .floor-stamp.plant.selected .floor-stamp-hit,
    .floor-stamp.toilet.selected .floor-stamp-hit {
        stroke: var(--floor-ink-strong);
        stroke-width: 0.4;
    }
    .floor-label-node ellipse,
    .floor-label-node rect:not(.floor-stamp-hit) {
        fill: var(--floor-accent-fill);
        stroke: var(--floor-accent);
        stroke-width: 0.35;
    }
    .floor-label-text {
        font-weight: 700;
        fill: var(--floor-ink-strong);
        pointer-events: none;
    }
    .floor-label-node.text-only .floor-label-text {
        fill: var(--floor-ink);
        font-weight: 600;
    }
    </style>